// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 1%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767px) {
  .elkevent-nav {
    padding-top: 5px;
  }
  .elkevent-nav .navbar-brand img {
    max-width: 100px;
  }
  .ptb-120 {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .section-title span {
    font-size: 13px;
  }
  .section-title h2 {
    font-size: 25px;
  }
  .section-title .btn {
    display: none;
  }
  .section-title .bg-title {
    font-size: 30px !important;
    line-height: 150% !important;
    /* left: auto;
    right: 0;
    transform: unset !important; */
  }
  p {
    font-size: 14px;
  }
  .btn {
    font-size: 14px;
    padding: 13px 24px;
  }
  .preloader .loader {
    margin: -80px 0 0 -55px;
  }
  .main-banner {
    height: 100%;
    padding-top: 150px;
    padding-bottom: 100px;
  }
  .main-banner-content {
    text-align: center;
  }
  .main-banner-content::before {
    display: none;
  }
  .main-banner-content h1 {
    font-size: 28px;
    line-height: 1.5;
    font-weight: 800;
  }
  .main-banner-content h1 br {
    display: none;
  }
  .main-banner-content p {
    font-size: 15px;
  }
  .main-banner-content ul {
    margin: 20px 0 30px;
  }
  .main-banner-content ul li {
    font-size: 15px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .main-banner-content .button-box .video-btn {
    margin-left: 15px;
    margin-top: 25px;
  }
  .main-banner-content.banner-content-center {
    margin: 0 auto 0;
    text-align: center;
    width: 90% !important;
  }
  .event-countdown {
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    margin: 50px auto 0;
    text-align: center;
    position: inherit;
  }
  .event-countdown #timer div {
    font-size: 30px;
    margin: 0 20px 0 0;
    position: relative;
  }
  .event-countdown #timer div:last-child {
    margin-right: 0;
  }
  .event-countdown #timer div:first-child {
    margin-left: 0;
  }
  .event-countdown #timer div span {
    margin-top: 0;
    font-size: 12px;
    position: relative;
    right: 0;
    top: 0;
    transform: unset;
    margin-top: -5px;
    letter-spacing: 1px;
  }
  .event-countdown #timer div#hours span {
    right: 0;
    margin-top: -5px;
  }
  .event-countdown #timer div#minutes span {
    right: 0;
    margin-top: -5px;
  }
  .event-countdown #timer div#seconds span {
    right: 0;
    margin-top: -5px;
  }
  .shape1,
  .shape2,
  .shape3,
  .shape4 {
    display: none;
  }
  .slideshow-banner .event-countdown {
    text-align: center;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 25px;
  }
  .slideshow-banner .event-countdown #timer div {
    font-size: 30px;
    margin: 0 22px 0 0;
  }
  .slideshow-banner .event-countdown #timer div:last-child {
    margin-right: 0;
  }
  .home-slides .swiper-button-next,
  .home-slides .swiper-button-prev {
    width: 35px;
    height: 35px;
    line-height: 35px;
    top: auto;
    bottom: 10px;
  }
  .home-slides .swiper-button-next::after,
  .home-slides .swiper-button-prev::after {
    font-size: 20px;
  }
  .about-content span {
    font-size: 16px;
  }
  .about-content h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }
  .about-content h6 {
    font-size: 15px;
  }
  .about-image {
    margin-top: 40px;
  }
  .about-image .about-img1 {
    right: 0;
    top: 0;
    width: 100%;
  }
  .about-image .about-img2 {
    position: relative;
    left: 0;
    bottom: 0;
    width: 100%;
    margin-top: 20px;
  }
  .about-image .shape-img {
    top: 27%;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .about-image .btn {
    bottom: 0;
    right: 15px;
    transform: unset !important;
  }
  .about-area-two .about-content .signature {
    margin-bottom: 0;
  }
  .about-area-three .about-content .signature {
    margin-bottom: 0;
  }
  .about-area-three .about-image {
    margin-top: 0;
    margin-bottom: 30px;
  }
  .about-area-three .about-image .about-img1 {
    margin-top: 0;
  }
  .about-area-three .about-image .btn {
    left: auto;
    bottom: 30px;
    right: 15px;
  }
  .countdown-area .event-countdown {
    margin: 0;
  }
  .countdown-area .event-countdown #timer {
    overflow: hidden;
    margin: 0 -10px;
    text-align: center;
  }
  .countdown-area .event-countdown #timer div {
    margin: 0;
    text-align: center;
    padding: 0 10px;
  }
  .why-choose-us {
    padding-top: 60px;
    padding-bottom: 35px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .why-choose-us::before {
    opacity: 0.8;
  }
  .single-box {
    height: 100%;
    margin-bottom: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border: none !important;
  }
  .single-box .d-table {
    height: auto;
    display: block;
  }
  .single-box .d-table-cell {
    display: block;
  }
  .single-box .content {
    position: relative;
    padding-left: 0;
    padding-right: 0;
  }
  .single-box .content .btn {
    opacity: 1;
    visibility: visible;
    margin-top: 20px;
  }
  .single-box .content .icon {
    font-size: 35px;
  }
  .single-box .content h3 {
    font-size: 20px;
  }
  .single-box:hover .content,
  .single-box:focus .content {
    bottom: 0;
  }
  .single-box:hover .content p,
  .single-box:focus .content p {
    margin-bottom: 0;
  }
  .single-box::before {
    display: none;
  }
  .why-choose-content {
    padding: 35px 25px;
  }
  .why-choose-content h3 {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .why-choose-content span {
    margin: 0 auto 0;
    font-size: 60px;
  }
  .single-speakers .speakers-content {
    bottom: 20px;
    left: 20px;
    text-align: center;
    width: 100%;
  }
  .single-speakers .speakers-content h3 {
    font-size: 18px;
    margin-bottom: 0;
  }
  .single-speakers .speakers-content span {
    font-size: 14px;
  }
  .single-speakers:hover .speakers-content,
  .single-speakers:focus .speakers-content {
    bottom: 20px;
  }
  .single-speakers ul {
    padding: 10px;
  }
  .single-speakers ul li a {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
  }
  .elkevent-single-speakers .speakers-content h3 {
    font-size: 18px;
  }
  .elkevent-single-speakers .speakers-content span {
    font-size: 14px;
  }
  .speakers-area-two {
    padding-bottom: 30px;
  }
  .single-speakers-box .speakers-content h3 {
    font-size: 20px;
  }
  .single-speakers-box .speakers-content span {
    font-size: 13px;
  }
  .event-tabs .react-tabs__tab-list {
    display: block;
    margin-bottom: 0;
  }
  .event-tabs .react-tabs__tab-list li {
    display: block;
    font-size: 20px;
    padding: 20px 10px;
  }
  .event-tabs .react-tabs__tab-list li::before {
    display: none;
  }
  .event-tabs .react-tabs__tab-list li span {
    font-size: 16px;
  }
  .event-tabs .react-tabs__tab-panel {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .event-tabs .react-tabs__tab-panel .accordion .accordion__item {
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__item
    .accordion__button {
    display: block;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 25px;
    padding-top: 0;
    text-align: center;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__item
    .accordion__button
    .author {
    margin-right: auto;
    margin-bottom: 15px;
    margin-left: auto;
    position: relative;
    top: 0;
    transform: unset;
    right: 0;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__item
    .accordion__button
    .schedule-info
    h3 {
    margin-bottom: 10px;
    line-height: 28px;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__item
    .accordion__button
    .schedule-info
    ul
    li {
    margin-right: 0;
    margin-bottom: 10px;
    display: block;
    font-size: 14px;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__item
    .accordion__button
    .schedule-info
    ul
    li:last-child {
    margin-bottom: 0;
  }
  .event-tabs .react-tabs__tab-panel .accordion .accordion__panel {
    padding: 0;
  }
  .event-tabs .react-tabs__tab-panel .accordion .accordion__panel p {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__panel
    .row
    .text-right {
    text-align: left !important;
    margin-top: 15px;
  }
  .schedule-slides-item .single-schedule {
    padding: 0 0 0 0;
  }
  .schedule-slides-item .single-schedule .schedule-date {
    font-size: 20px;
    padding: 25px;
    position: relative;
    width: auto;
  }
  .schedule-slides-item .single-schedule .schedule-date span {
    font-size: 14px;
  }
  .schedule-slides-item .single-schedule .schedule-content {
    display: block;
    text-align: center;
  }
  .schedule-slides-item .single-schedule .schedule-content .author {
    margin-right: auto;
    margin-bottom: 15px;
    margin-left: auto;
  }
  .schedule-slides-item .single-schedule .schedule-content .schedule-info h3 {
    margin-bottom: 12px;
    line-height: 28px;
  }
  .schedule-slides-item
    .single-schedule
    .schedule-content
    .schedule-info
    ul
    li {
    margin-right: 0;
    margin-bottom: 10px;
    display: block;
    font-size: 14px;
  }
  .schedule-slides-item
    .single-schedule
    .schedule-content
    .schedule-info
    ul
    li:last-child {
    margin-bottom: 0;
  }
  .schedule-style-three {
    padding-bottom: 30px;
  }
  .single-schedule-item .schedule-date {
    font-size: 20px;
    padding: 25px;
    position: relative;
    width: auto;
  }
  .single-schedule-item .schedule-date span {
    font-size: 14px;
  }
  .single-schedule-item .schedule-item-wrapper .schedule-content {
    display: block;
    text-align: center;
  }
  .single-schedule-item .schedule-item-wrapper .schedule-content .author {
    margin-right: auto;
    margin-bottom: 15px;
    margin-left: auto;
  }
  .single-schedule-item
    .schedule-item-wrapper
    .schedule-content
    .schedule-info
    h3 {
    margin-bottom: 12px;
    line-height: 28px;
  }
  .single-schedule-item
    .schedule-item-wrapper
    .schedule-content
    .schedule-info
    ul
    li {
    margin-right: 0;
    margin-bottom: 10px;
    display: block;
    font-size: 14px;
  }
  .single-schedule-item
    .schedule-item-wrapper
    .schedule-content
    .schedule-info
    ul
    li:last-child {
    margin-bottom: 0;
  }
  .btn-box {
    margin-top: 20px;
  }
  .btn-box .btn {
    margin: 20px 10px 0;
  }
  .schedule-slides.owl-theme .owl-nav {
    margin-top: 30px;
  }
  .schedule-slides.owl-theme .owl-nav [class*="owl-"] {
    font-size: 25px;
    position: relative;
    left: 0;
    top: 0;
    right: 0 !important;
  }
  .schedule-style-four .col-lg-8 {
    order: 2;
  }
  .schedule-style-four .col-lg-4 {
    order: 1;
  }
  .funfacts-area {
    padding-bottom: 30px;
  }
  .single-funfact {
    margin-bottom: 30px;
  }
  .single-funfact .icon {
    font-size: 30px;
  }
  .single-funfact h3 {
    font-size: 35px;
    margin-top: 8px;
  }
  .single-funfact p {
    font-size: 13px;
  }
  .funFact {
    text-align: center;
    margin-bottom: 35px;
    padding-left: 0;
  }
  .funFact .icon {
    font-size: 30px;
    position: relative;
  }
  .funFact h3 {
    font-size: 35px;
    margin-top: 8px;
  }
  .funFact p {
    font-size: 14px;
  }
  .cta-area {
    text-align: center;
  }
  .cta-area span {
    font-size: 15px;
  }
  .cta-area h3 {
    font-size: 24px;
  }
  .cta-area .text-right {
    text-align: center !important;
    margin-top: 25px;
  }
  .pricing-area {
    padding-bottom: 30px;
  }
  .pricing-table-box {
    margin-bottom: 30px;
  }
  .pricing-table-box .title {
    font-size: 17px;
  }
  .pricing-table-box .price-value {
    font-size: 35px;
  }
  .pricing-table-box .price-value sup {
    font-size: 20px;
    top: -18px;
  }
  .pricing-table-box .pricing-content li {
    margin-bottom: 10px;
    padding-bottom: 10px;
    font-size: 14px;
  }
  .pricing-table-box .pricing-content li:last-child {
    margin-bottom: 0;
  }
  .pricing-plan {
    margin-bottom: 30px;
  }
  .pricing-plan h3 {
    font-size: 20px;
  }
  .pricing-plan h3 span {
    height: 130px;
    width: 130px;
    line-height: 135px;
    font-size: 25px;
  }
  .pricing-plan .pricing-content li {
    margin-bottom: 10px;
    padding-bottom: 10px;
    font-size: 14px;
  }
  .pricing-plan .pricing-content li:last-child {
    margin-bottom: 0;
  }
  .partner-area .section-title {
    text-align: center;
  }
  .partner-area .section-title .bar {
    display: none;
  }
  .partner-area .partner-title {
    margin-bottom: 40px;
    transform: unset !important;
  }
  .partner-area .partner-title h3 {
    font-size: 18px;
    font-weight: 600;
  }
  .single-blog-post .blog-post-content {
    padding: 20px;
  }
  .single-blog-post .blog-post-content .date {
    font-size: 13px;
  }
  .single-blog-post .blog-post-content h3 {
    line-height: 28px;
    font-size: 18px;
  }
  .blog-section {
    padding-bottom: 30px;
  }
  .single-blog-card .post-tag {
    top: 15px;
  }
  .single-blog-card .blog-post-content {
    padding: 0 20px 20px;
  }
  .single-blog-card .blog-post-content p,
  .single-blog-card .blog-post-content .read-more-btn {
    display: none;
  }
  .single-blog-card .blog-post-content h3 {
    font-size: 18px;
    margin-bottom: 0;
  }
  .single-blog-card:hover .post-tag,
  .single-blog-card:focus .post-tag {
    top: 15px;
  }
  .buy-tickets-area.ptb-120 {
    padding-bottom: 140px;
  }
  .subscribe-area::before {
    height: 74%;
  }
  .subscribe-area .subscribe-inner {
    padding: 20px;
  }
  .subscribe-area .subscribe-inner p {
    font-size: 13px;
  }
  .subscribe-area .subscribe-inner h2 a {
    font-size: 18px;
    line-height: 36px;
  }
  .subscribe-area .subscribe-inner .newsletter-form .form-control {
    height: 50px;
  }
  .subscribe-area .subscribe-inner .newsletter-form .btn {
    position: relative;
    height: 54px;
    display: block;
    width: 100%;
    margin-top: 10px;
  }
  .page-title-area {
    padding-top: 160px;
    padding-bottom: 100px;
  }
  .page-title-area h1 {
    font-size: 28px;
  }
  .page-title-area span {
    margin-top: 10px;
    font-size: 15px;
  }
  .page-title-area ul li {
    font-size: 15px;
  }
  .login-area {
    height: 100%;
    padding: 120px 15px 120px;
  }
  .login-area .login-form p {
    text-align: center;
  }
  .login-area .login-form p a.pull-right {
    float: unset;
    margin-top: 5px;
  }
  .login-area .login-form p a.pull-left {
    float: unset;
  }
  .signup-area {
    height: 100%;
    padding: 120px 15px 120px;
  }
  .signup-area .signup-form h3 {
    font-size: 20px;
  }
  .coming-soon {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .coming-soon .coming-soon-content h1 {
    font-size: 30px;
    line-height: 45px;
  }
  .coming-soon .coming-soon-content #timer div {
    font-size: 40px;
    width: 120px;
    height: 120px;
    padding-top: 27px;
    line-height: 39px;
    margin: 0 5px 15px;
  }
  .coming-soon .coming-soon-content form button {
    position: relative;
    right: 0;
    top: 0;
    width: 100%;
    border-radius: 30px;
    margin-top: 10px;
    padding: 13px 0;
  }
  .error-area h1 {
    font-size: 110px;
    line-height: 85px;
  }
  .error-area h3 {
    margin: 30px 0 15px;
    font-size: 20px;
  }
  .faq-accordion {
    box-shadow: unset;
    padding: 0;
  }
  .faq-accordion .accordion .accordion-title {
    padding: 10px 10px 10px 50px;
    font-size: 14px;
  }
  .faq-contact {
    box-shadow: unset;
    padding: 0;
  }
  .faq-contact h3 {
    font-size: 20px;
    margin-bottom: 25px;
  }
  .sidebar {
    margin-top: 50px;
  }
  .sidebar .widget .widget-title {
    font-size: 18px;
  }
  .sidebar .widget.widget_recent_entries ul li h5 {
    font-size: 14px;
  }
  .blog-details h3 {
    font-size: 20px;
    line-height: 30px;
  }
  .blog-details blockquote,
  .blog-details .blockquote {
    padding: 88px 20px 20px 20px;
    border-width: 3px;
  }
  .blog-details blockquote::before,
  .blog-details .blockquote::before {
    left: 20px;
    top: 20%;
  }
  .blog-details blockquote p,
  .blog-details .blockquote p {
    font-size: 15px;
  }
  .post-tag-media {
    text-align: center;
  }
  .post-tag-media ul.social-share {
    text-align: center;
    margin-top: 15px;
  }
  .comments-area .comments-title,
  .comments-area .comment-reply-title {
    font-size: 20px;
  }
  .comments-area ol li .comment-body,
  .comments-area ul li .comment-body {
    padding: 20px 15px;
  }
  .comments-area ol li .comment-body .comment-meta .comment-author .fn,
  .comments-area ul li .comment-body .comment-meta .comment-author .fn {
    font-size: 16px;
  }
  .comments-area ol li .comment-body .reply,
  .comments-area ul li .comment-body .reply {
    position: relative;
    right: 0;
    top: 0;
    margin-top: 20px;
  }
  .contact-box {
    margin-bottom: 30px;
  }
  .contact-box h4 {
    font-size: 18px;
  }
  .contact-form {
    margin-top: 0;
  }
  .leave-your-message h3 {
    font-size: 18px;
  }
  #contactForm {
    margin-top: 30px;
    padding: 20px 15px;
  }
  .footer-area {
    padding-top: 60px;
  }
  .single-footer-widget {
    margin-bottom: 30px;
  }
  .single-footer-widget h3 {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .single-footer-widget span {
    font-size: 14px;
  }
  .single-footer-widget a {
    font-size: 14px;
  }
  .copyright-area {
    margin-top: 20px;
  }
  .copyright-area ul {
    margin: 25px 0 18px;
  }
  .countdown1 {
    /* position: initial; */
    text-align: center !important;
  }
  .countdown1 #timer div {
    font-size: 30px;
    margin: 0 20px 0 0;
  }
  .blog-slides.owl-theme .owl-nav.disabled + .owl-dots {
    margin-top: 0;
  }
  .buy-tickets {
    text-align: center;
  }
  .buy-tickets .buy-ticket-btn {
    text-align: center;
    margin-top: 30px;
  }
  .copyright-area .logo img {
    max-width: 100px;
  }
  .speakers-area .p-0 {
    padding: 12px !important;
  }
  .speakers-area .single-speakers,
  /* .speakers-area .elkevent-single-speakers {
    margin-bottom: 30px;
  } */
  section.speakers-area.ptb-120.pb-0 {
    padding-bottom: 30px !important;
  }
  .slideshow-banner .main-banner-content {
    margin-top: 0;
  }
  .modal-video-body {
    padding: 0 20px;
  }
  .modal-video-body .modal-video-close-btn {
    right: 0;
  }
}
@media only screen and (min-width: 423px) and (max-width: 767px) {
  .main-banner-content .button-box .video-btn {
    margin-top: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .schedule-area .tabs li {
    width: 50%;
    display: inline-block;
  }
  .why-choose-us-two {
    max-width: 540px;
    width: 100%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .speakers-area .p-0 {
    padding: 12px !important;
  }
  .elkevent-nav {
    padding-top: 10px;
  }
  .elkevent-nav .navbar-brand {
    padding-top: 0;
  }
  .elkevent-nav .navbar-brand img {
    max-width: 90px;
  }
  .countdown1 {
    bottom: 25px !important;
  }
  .copyright-area .logo img {
    max-width: 100px;
  }
  .ptb-120 {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .event-countdown {
    bottom: 15px;
  }
  .event-countdown #timer span {
    font-size: 12px;
  }
  .slideshow-banner .event-countdown {
    text-align: center;
  }
  .buy-tickets {
    text-align: center;
  }
  .buy-tickets .buy-ticket-btn {
    text-align: center;
    margin-top: 30px;
  }
  .section-title span {
    font-size: 14px;
  }
  .section-title h2 {
    font-size: 30px;
  }
  .section-title .bg-title {
    font-size: 100px !important;
    line-height: 150% !important;
    right: 20%;
    margin-top: -10px;
    transform: unset !important;
  }
  .section-title .btn {
    margin-top: -25px;
  }
  .elkevent-mobile-nav .logo {
    left: 40px !important;
  }
  .elkevent-mobile-nav.mean-container a.meanmenu-reveal {
    padding: 12px 40px 0 0;
  }
  .main-banner {
    height: 100%;
    padding-top: 200px;
    padding-bottom: 200px;
  }
  .main-banner-content {
    text-align: center;
  }
  .main-banner-content::before {
    display: none;
  }
  .main-banner-content p {
    font-size: 18px;
  }
  .main-banner-content h1 {
    font-size: 40px;
    line-height: 1.4;
  }
  .main-banner-content ul li {
    font-size: 15px;
  }
  .main-banner-content.banner-content-center {
    margin-top: 0;
  }
  .event-countdown #timer div {
    margin: 0 25px;
    font-size: 50px;
  }
  .event-countdown #timer div span {
    font-size: 13px;
    right: -30px;
    margin-top: -11px;
    letter-spacing: 0;
  }
  .event-countdown #timer div#hours span {
    right: -36px;
    margin-top: -10px;
  }
  .event-countdown #timer div#minutes span {
    right: -42px;
    margin-top: -10px;
  }
  .event-countdown #timer div#seconds span {
    right: -44px;
    margin-top: -10px;
  }
  .subscribe-area .subscribe-inner .newsletter-form .btn {
    height: 50px;
  }
  .countdown-area .event-countdown #timer div {
    margin: 0 30px;
  }
  .about-content span {
    font-size: 16px;
  }
  .about-content h2 {
    font-size: 30px;
    margin-bottom: 20px;
  }
  .about-image {
    margin-top: 50px;
  }
  .about-image .about-img1 {
    position: relative;
    right: 0;
    top: 0;
  }
  .about-image .about-img2 {
    display: none;
  }
  .about-image .btn {
    bottom: 0;
    right: 25px;
    transform: unset !important;
  }
  .about-area-three .about-image {
    margin-bottom: 30px;
  }
  .about-area-three .about-image .about-img1 {
    width: 100%;
  }
  .about-area-three .about-image .btn {
    bottom: 30px;
  }
  .why-choose-us {
    padding-top: 80px;
    padding-bottom: 50px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .single-box {
    height: 100%;
    margin-bottom: 30px;
    border: none !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  .single-box .d-table {
    height: auto;
    display: block;
  }
  .single-box .d-table-cell {
    display: block;
  }
  .single-box .content {
    position: relative;
    z-index: 2;
    padding-left: 0;
    padding-right: 0;
  }
  .single-box .content .btn {
    opacity: 1;
    visibility: visible;
    margin-top: 20px;
  }
  .single-box .content .icon {
    font-size: 35px;
    line-height: 40px;
  }
  .single-box .content h3 {
    font-size: 22px;
  }
  .single-box:hover .content,
  .single-box:focus .content {
    bottom: 0;
  }
  .single-box:hover .content p,
  .single-box:focus .content p {
    margin-bottom: 0;
  }
  .why-choose-content h3 {
    font-size: 22px;
  }
  .why-choose-us-two .col-lg-4:nth-child(1) {
    order: 1;
  }
  .why-choose-us-two .col-lg-4:nth-child(2) {
    order: 2;
  }
  .why-choose-us-two .col-lg-4:nth-child(3) {
    order: 4;
  }
  .why-choose-us-two .col-lg-4:nth-child(4) {
    order: 3;
  }
  .why-choose-us-two .col-lg-4:nth-child(5) {
    order: 5;
  }
  .why-choose-us-two .col-lg-4:nth-child(6) {
    order: 6;
  }
  .why-choose-us-two .col-lg-4:nth-child(7) {
    order: 7;
  }
  .why-choose-us-two .col-lg-4:nth-child(8) {
    order: 8;
  }
  .single-speakers .speakers-content h3 {
    font-size: 22px;
  }
  .elkevent-single-speakers .speakers-content h3 {
    font-size: 20px;
  }
  .speakers-area-two {
    padding-bottom: 50px;
  }
  .single-speakers-box .speakers-content h3 {
    font-size: 20px;
  }
  .shape1,
  .shape2,
  .shape3,
  .shape4 {
    display: none;
  }
  .event-tabs .react-tabs__tab-list li {
    font-size: 18px;
  }
  .event-tabs .react-tabs__tab-list li span {
    font-size: 16px;
  }
  .event-tabs
    .accordion__panel
    .accordion
    .accordion__item
    .accordion__button
    .schedule-info
    h3 {
    padding-right: 115px;
    line-height: 1.4;
  }
  .event-tabs
    .accordion__panel
    .accordion
    .accordion__item
    .accordion__button
    .schedule-info
    ul
    li {
    font-size: 13px;
  }
  .schedule-slides-item .single-schedule {
    padding: 0 0 0 175px;
  }
  .schedule-slides-item .single-schedule .schedule-date {
    font-size: 22px;
    padding: 20px 20px;
    width: 175px;
  }
  .schedule-slides-item .single-schedule .schedule-date span {
    font-size: 14px;
  }
  .schedule-slides-item .single-schedule .schedule-content .schedule-info h3 {
    margin-bottom: 10px;
  }
  .schedule-slides-item
    .single-schedule
    .schedule-content
    .schedule-info
    ul
    li {
    margin-right: 10px;
    font-size: 13px;
  }
  .schedule-slides.owl-theme .owl-nav [class*="owl-"] {
    left: -15px;
  }
  .schedule-slides.owl-theme .owl-nav [class*="owl-"].owl-next {
    right: -15px;
    left: auto;
  }
  .schedule-style-three {
    padding-bottom: 50px;
  }
  .single-schedule-item
    .schedule-item-wrapper
    .schedule-content
    .schedule-info
    ul
    li {
    font-size: 14px;
  }
  .schedule-style-four
    .tab_content
    .tabs_item
    .accordion
    .accordion-item
    .accordion-title
    .schedule-info
    ul
    li {
    font-size: 14px;
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .schedule-style-four
    .tab_content
    .tabs_item
    .accordion
    .accordion-item
    .accordion-title
    .schedule-info
    ul
    li:last-child {
    margin-bottom: 0;
  }
  .single-funfact .icon {
    font-size: 35px;
  }
  .single-funfact h3 {
    font-size: 40px;
  }
  .funFact {
    padding-left: 0;
    text-align: center;
  }
  .funFact .icon {
    font-size: 35px;
    position: relative;
  }
  .funFact h3 {
    margin-top: 10px;
    font-size: 40px;
  }
  /* .event-countdown {
    right: 0;
    text-align: center;
    left: 0;
  } */
  .pricing-area {
    padding-bottom: 50px;
  }
  .pricing-table-box {
    margin-bottom: 30px;
  }
  .pricing-table-box .title {
    font-size: 22px;
  }
  .pricing-table-box .price-value {
    font-size: 40px;
  }
  .pricing-table-box .price-value sup {
    font-size: 20px;
    top: -20px;
  }
  .pricing-plan {
    margin-bottom: 30px;
  }
  .pricing-plan h3 {
    font-size: 22px;
  }
  .pricing-plan h3 span {
    height: 140px;
    width: 140px;
    line-height: 145px;
    font-size: 30px;
  }
  .partner-area .partner-title {
    margin-bottom: 40px;
    transform: unset !important;
  }
  .partner-area .partner-title h3 {
    font-size: 20px;
  }
  .cta-area span {
    font-size: 16px;
  }
  .cta-area h3 {
    font-size: 30px;
  }
  .cta-area .text-right {
    text-align: left !important;
    margin-top: 25px;
  }
  .single-blog-post .blog-post-content h3 {
    font-size: 20px;
  }
  .single-blog-card .blog-post-content {
    padding: 0 20px 20px;
  }
  .single-blog-card .blog-post-content h3 {
    margin-bottom: 0;
    font-size: 20px;
  }
  .single-blog-card .blog-post-content p,
  .single-blog-card .blog-post-content .read-more-btn {
    display: none;
  }
  .buy-tickets-area.ptb-120 {
    padding-bottom: 175px;
  }
  .subscribe-area .subscribe-inner p {
    font-size: 15px;
  }
  .subscribe-area .subscribe-inner h2 a {
    font-size: 30px;
  }
  .page-title-area {
    padding-top: 160px;
    padding-bottom: 120px;
  }
  .page-title-area h1 {
    font-size: 30px;
  }
  .page-title-area span {
    margin-top: 8px;
    font-size: 16px;
  }
  .login-area {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .signup-area {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .coming-soon {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .faq-accordion {
    padding: 30px;
  }
  .faq-contact {
    padding: 30px;
  }
  .faq-contact h3 {
    font-size: 22px;
  }
  .sidebar {
    margin-top: 50px;
  }
  .sidebar .widget .widget-title {
    font-size: 20px;
  }
  .comments-area .comments-title,
  .comments-area .comment-reply-title {
    font-size: 20px;
    margin-bottom: 25px;
  }
  .contact-box {
    margin-bottom: 30px;
    padding: 30px 20px 30px 75px;
  }
  .contact-box .icon {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .contact-box h4 {
    font-size: 18px;
    margin-bottom: 13px;
  }
  .contact-box p {
    margin-bottom: 3px;
    font-size: 14px;
  }
  .contact-box p:last-child {
    margin-bottom: 0;
  }
  .contact-form {
    margin-top: 20px;
  }
  .leave-your-message h3 {
    margin-bottom: 12px;
    font-size: 20px;
  }
  #contactForm {
    margin-top: 30px;
  }
  .footer-area {
    padding-top: 80px;
  }
  .single-footer-widget h3 {
    font-size: 22px;
  }
  .copyright-area {
    margin-top: 60px;
  }
  .elkevent-nav nav .navbar-nav .nav-item a {
    font-size: 15px;
    /* margin-left: 11px;
    margin-right: 11px; */
  }
  .elkevent-nav nav .navbar-nav .nav-item:nth-last-child(1) .dropdown-menu,
  .elkevent-nav nav .navbar-nav .nav-item:nth-last-child(2) .dropdown-menu,
  .elkevent-nav nav .navbar-nav .nav-item:nth-last-child(3) .dropdown-menu {
    left: auto;
    right: 0;
  }
  .countdown1 #timer div {
    margin: 0 20px;
    font-size: 40px;
  }
  .single-funfact {
    margin-bottom: 30px;
  }
  .funfacts-area.ptb-120 {
    padding-bottom: 50px;
  }
  .modal-video-body {
    padding: 0 30px;
  }
  .modal-video-body .modal-video-close-btn {
    right: 0;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .elkevent-nav .navbar-brand {
    padding-top: 0;
  }
  .elkevent-nav .navbar-brand img {
    max-width: 100px;
  }
  .copyright-area .logo img {
    max-width: 100px;
  }
  .elkevent-nav nav .navbar-nav .nav-item a {
    font-size: 15px;
  }
  .main-banner-content p {
    font-size: 20px;
  }
  .main-banner-content h1 {
    font-size: 45px;
    font-weight: 800;
    line-height: 1.3;
  }
  .event-countdown #timer div {
    font-size: 50px;
  }
  .about-content span {
    font-size: 16px;
  }
  .about-content h2 {
    font-size: 27px;
    margin-bottom: 20px;
  }
  .about-content h6 {
    margin-bottom: 15px;
  }
  .about-content .signature {
    margin-top: 25px;
  }
  .about-image .about-img1 {
    width: 85%;
    top: -145px;
    right: -40px;
  }
  .about-image .about-img2 {
    left: 0;
    bottom: -142px;
  }
  .about-image .btn {
    bottom: 0;
    transform: unset !important;
  }
  .about-area-three .about-image img {
    width: 100%;
  }
  .why-choose-content {
    padding: 10px;
  }
  .why-choose-content h3 {
    font-size: 22px;
    margin-bottom: 10px;
  }
  .single-box .content {
    padding-left: 10px;
    padding-right: 10px;
  }
  .single-box .content h3 {
    font-size: 22px;
  }
  .single-box .content::before {
    display: none;
  }
  .cta-area h3 {
    font-size: 30px;
  }
  .cta-area span {
    font-size: 15px;
  }
  .single-speakers .speakers-content {
    bottom: 15px;
    left: 15px;
  }
  .single-speakers .speakers-content h3 {
    font-size: 18px;
  }
  .single-speakers ul li a {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
  }
  .single-speakers:hover .speakers-content,
  .single-speakers:focus .speakers-content {
    bottom: 12px;
  }
  .elkevent-single-speakers .speakers-content {
    padding: 15px;
  }
  .elkevent-single-speakers .speakers-content h3 {
    font-size: 18px;
  }
  .elkevent-single-speakers .speakers-content span {
    font-size: 13px;
    margin-top: 5px;
  }
  .elkevent-single-speakers ul li a {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
  }
  .single-speakers-box .speakers-content h3 {
    font-size: 20px;
  }
  .section-title span {
    font-size: 15px;
  }
  .section-title h2 {
    font-size: 34px;
  }
  .section-title .bg-title {
    transform: unset !important;
    font-size: 80px !important;
  }
  .event-tabs
    .react-tabs__tab-panel
    .accordion
    .accordion__item
    .accordion__button
    .schedule-info
    h3 {
    font-size: 20px;
  }
  .single-schedule-item
    .schedule-item-wrapper
    .schedule-content
    .schedule-info
    ul
    li {
    font-size: 14px;
    display: block;
    margin-right: 0;
    margin-bottom: 5px;
  }
  .single-schedule-item
    .schedule-item-wrapper
    .schedule-content
    .schedule-info
    ul
    li:last-child {
    margin-bottom: 0;
  }
  .pricing-table-box .title {
    font-size: 18px;
  }
  .pricing-table-box .price-value {
    font-size: 40px;
  }
  .partner-area .partner-title {
    transform: unset !important;
  }
  .partner-area .partner-title h3 {
    font-size: 20px;
  }
  .subscribe-area .subscribe-inner p {
    font-size: 15px;
  }
  .subscribe-area .subscribe-inner h2 a {
    font-size: 34px;
  }
  .sidebar .widget .widget-title {
    font-size: 20px;
  }
  .countdown1 #timer div {
    font-size: 50px;
  }
  .elkevent-nav nav .others-option .btn {
    font-size: 14px;
    padding: 14px 20px;
  }
  .tabs li a {
    font-size: 20px;
  }
  .home-slides .main-banner-content {
    text-align: center;
  }
  .page-title-area {
    padding-top: 200px;
    padding-bottom: 130px;
  }
  .slideshow-banner .main-banner-content {
    text-align: center;
  }
  .slideshow-banner .event-countdown {
    text-align: center;
    bottom: 5px;
  }
  .slideshow-banner .event-countdown #timer span {
    font-size: 10px;
    right: -35px;
  }
  .slideshow-banner .event-countdown #timer div {
    font-size: 45px;
  }
  .slideshow-banner .event-countdown #timer div#hours span {
    right: -41px;
  }
  .slideshow-banner .event-countdown #timer div#minutes span {
    right: -48px;
  }
  .slideshow-banner .event-countdown #timer div#seconds span {
    right: -50px;
  }
}
@media only screen and (min-width: 1600px) {
  .main-banner {
    height: 100vh;
  }
  .event-countdown {
    right: 20%;
  }
  .about-image .about-img1 {
    right: -200px;
  }

  .container {
    max-width: 80% !important;
  }
}
@media only screen and (max-width: 991px) {
  .elkevent-nav nav .navbar-toggler {
    outline: 0;
    color: #ffffff;
    border-color: transparent !important;
  }
  .elkevent-nav nav .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .elkevent-nav nav .collapse {
    background-color: #000000;
    padding: 15px 12px;
    margin-top: 5px;
    overflow-y: auto;
    max-height: 60vh;
  }
  .elkevent-nav nav .collapse::-webkit-scrollbar {
    width: 10px;
  }
  .elkevent-nav nav .collapse::-webkit-scrollbar-track {
    background: #f1f1f150;
  }
  .elkevent-nav nav .collapse::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
  }
  .elkevent-nav nav .collapse::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .elkevent-nav nav .navbar-nav .nav-item {
    padding: 8px 0;
  }
  .elkevent-nav nav .navbar-nav .nav-item a {
    font-size: 15px;
    margin: 0;
  }
  .elkevent-nav nav .navbar-nav .nav-item .dropdown-menu {
    padding-top: 12px;
    padding-bottom: 12px;
    position: relative;
    opacity: 1;
    visibility: visible;
    top: 0 !important;
    width: 100%;
    margin-top: 10px;
  }
  .elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a {
    font-size: 14px;
  }
  .elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li .dropdown-menu {
    padding-top: 12px;
    padding-bottom: 12px;
    position: relative;
    opacity: 1 !important;
    visibility: visible !important;
    top: 0 !important;
    width: 90%;
    /* left: 15px; */
    margin-top: 0;
    margin-bottom: 10px;
    background: #30334c;
  }
  .elkevent-nav nav .others-option {
    margin-left: 0;
    margin-top: 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/responsive.scss","webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACI;IACI,gBAAA;ECCN;EDCU;IACI,gBAAA;ECCd;EDGE;IAEQ,iBAAA;IACA,oBAAA;ECFV;EDME;IACI,eAAA;ECJN;EDMM;IACI,eAAA;ECJV;EDMM;IACI,aAAA;ECJV;EDMM;IACI,0BAAA;ICJV,4BAAA;IDMM;;kCAEI;ECJV;EACA;IACA,eAAA;EDQE;ECNF;IACA,eAAA;IDQE,kBAAA;ECNF;EACA;IACA,uBAAA;EDUM;ECRN;IACA,YAAA;IDYE,kBAAA;IACI,qBAAA;ECVN;EACA;IACA,kBAAA;EDcE;ECZF;IACA,aAAA;EDaM;ECXN;IACA,eAAA;IDaM,gBAAA;IACI,gBAAA;ECXV;EACA;IACA,aAAA;EDaU;ECXV;IACA,eAAA;EDcM;ECZN;IACA,mBAAA;EDcM;ECZN;IACA,eAAA;IDaU,eAAA;IACI,kBAAA;ECXd;EACA;IACA,iBAAA;IDeU,gBAAA;ECbV;EACA;IACA,gBAAA;IDkBM,kBAAA;IACI,qBAAA;EChBV;EACA;IDmBE,SAAA;IACI,2BAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;ECjBN;EDoBU;IACI,eAAA;IACA,kBAAA;IACA,kBAAA;EClBd;EDmBc;IACI,eAAA;ECjBlB;EDmBc;IACI,cAAA;ECjBlB;EDoBc;IACI,aAAA;IACA,eAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EClBlB;EDqBkB;IACI,QAAA;IACA,gBAAA;ECnBtB;EDuBkB;IACI,QAAA;IACA,gBAAA;ECrBtB;EDyBkB;IACI,QAAA;IACA,gBAAA;ECvBtB;ED6BE;;;;IAKQ,aAAA;EC5BV;EACA;ID+Bc,kBAAA;IC7Bd,cAAA;IDgCc,aAAA;IACI,mBAAA;EC9BlB;EACA;ID+BkB,eAAA;IACI,kBAAA;EC7BtB;EDoCM;IACI,eAAA;EClCV;EACA;;IDqCU,WAAA;IClCV,YAAA;IDoCU,iBAAA;IAEQ,SAAA;ICnClB,YAAA;ED0CM;ECxCN;;ID2CM,eAAA;ECxCN;EACA;IACA,eAAA;ED0CM;ECxCN;IACA,eAAA;ID2CE,mBAAA;ECzCF;EACA;ID2CM,eAAA;ECzCN;EACA;ID2CU,gBAAA;ECzCV;ED2CM;IACI,QAAA;IACA,MAAA;IACA,WAAA;ECzCV;EACA;IACA,kBAAA;ID2CM,OAAA;IACI,SAAA;IACA,WAAA;IACA,gBAAA;ECzCV;EACA;ID2CM,QAAA;IACI,OAAA;IACA,QAAA;IACA,cAAA;ECzCV;ED8CU;IACI,SAAA;IC5Cd,WAAA;IDkDU,2BAAA;EChDV;EACA;IDmDM,gBAAA;ECjDN;EACA;IACA,gBAAA;EDoDU;EClDV;IACA,aAAA;IDoDU,mBAAA;EClDV;EACA;IDoDc,aAAA;EClDd;EDwDM;IACI,UAAA;ICtDV,YAAA;IDwDU,WAAA;ECtDV;EACA;IDwDc,SAAA;ECtDd;EDwDc;IACI,gBAAA;IACA,eAAA;IACA,kBAAA;ECtDlB;ED4DE;IAEQ,SAAA;IACA,kBAAA;IACA,eAAA;EC3DV;EACA;ID6DM,iBAAA;IACI,oBAAA;IC3DV,kBAAA;ID8DE,mBAAA;EC5DF;EACA;ID+DU,YAAA;EC7DV;EACA;IACA,YAAA;IDgEM,mBAAA;IACI,kBAAA;IACA,mBAAA;IC9DV,uBAAA;EDgEU;EC9DV;IACA,YAAA;IDiEM,cAAA;EC/DN;EACA;IDkEc,cAAA;EChEd;EDkEU;IACI,kBAAA;IACA,eAAA;IACA,gBAAA;EChEd;EDkEU;IACI,UAAA;IChEd,mBAAA;IDkEU,gBAAA;EChEV;EACA;IDsEU,eAAA;ECpEV;EACA;IDsEc,eAAA;ECpEd;EACA;;IDyEU,SAAA;ECtEV;EDyEE;;ICtEF,gBAAA;EDyEM;ECvEN;IDyEU,aAAA;ECvEV;EDyEM;IACI,kBAAA;ECvEV;EACA;ID4EM,eAAA;IACI,mBAAA;EC1EV;EACA;ID4EU,gBAAA;IC1EV,eAAA;ED4EU;EC1EV;ID4Ec,YAAA;IC1Ed,UAAA;ID4EU,kBAAA;IACI,WAAA;EC1Ed;ED8EU;IACI,eAAA;IC5Ed,gBAAA;ED+EM;EC7EN;IACA,eAAA;EDgFc;EC9Ed;;IDiFkB,YAAA;EC9ElB;EACA;IDqFU,aAAA;ECnFV;EACA;IDqFU,WAAA;IACI,YAAA;ICnFd,iBAAA;IDuFE,eAAA;ECrFF;EACA;IDyFU,eAAA;ECvFV;EACA;IDyFU,eAAA;ECvFV;EACA;ID6FM,oBAAA;EC3FN;EACA;IACA,eAAA;ED6FU;EC3FV;IDgGc,eAAA;EC9Fd;EACA;IDyFc,cAAA;IACI,gBAAA;ECvFlB;ED6Fc;IACI,cAAA;IC3FlB,eAAA;IDgGM,kBAAA;EC9FN;EACA;IDiGc,aAAA;EC/Fd;EACA;IDkGc,eAAA;EChGd;EACA;IDmGsB,kBAAA;IACA,mBAAA;ICjGtB,oBAAA;IDoGkB,iBAAA;EClGlB;EACA;IDoGsB,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,iBAAA;EClGtB;EDoGsB;;;;;IAOI,cAAA;IACA,eAAA;IACA,gBAAA;ICpG1B,oBAAA;IDuG0B,cAAA;IACI,kBAAA;ECrG9B;EACA;;;;;;ID+GkC,kBAAA;ICxGlC,mBAAA;ID0GkC,iBAAA;IACI,kBAAA;ICxGtC,MAAA;ID+Gc,gBAAA;IACI,QAAA;EC7GlB;ED8GkB;;;;;;;ICtGlB,mBAAA;IDsHM,iBAAA;ECpHN;EACA;;;;;;;;ID6HkB,eAAA;ICpHlB,mBAAA;IDuHU,cAAA;IACI,eAAA;ECrHd;EACA;;;;;;;;IDiIsB,gBAAA;ECxHtB;EACA;ID2HsB,UAAA;ECzHtB;EACA;ID6H0B,eAAA;IACA,mBAAA;EC3H1B;ED6H0B;;;;;;IAapB,2BAAA;IACI,gBAAA;EClIV;EACA;IDoIU,gBAAA;EClIV;EDoIU;IACI,eAAA;IClId,aAAA;IDsIU,kBAAA;IACI,WAAA;ECpId;EACA;IDsIc,eAAA;ECpId;EACA;IDuIsB,cAAA;ICrItB,kBAAA;EDyIkB;ECvIlB;IDyIsB,kBAAA;IACA,mBAAA;ICvItB,iBAAA;ED0IsB;ECxItB;ID2I8B,mBAAA;IAEJ,iBAAA;EC1I1B;EACA;;;;;;IAMA,eAAA;IDkJM,mBAAA;IACI,cAAA;IChJV,eAAA;EDqJU;ECnJV;;;;;;ID0JkB,gBAAA;ECnJlB;EACA;IDyJM,oBAAA;ECvJN;EACA;IDyJM,eAAA;IACI,aAAA;ICvJV,kBAAA;ID2JE,WAAA;ECzJF;EACA;ID2JE,eAAA;ECzJF;EACA;ID2JM,cAAA;IACI,kBAAA;ECzJV;ED2JM;IACI,kBAAA;IACA,mBAAA;ICzJV,iBAAA;ED2JM;ECzJN;;;;;IDgKM,mBAAA;IC1JN,iBAAA;ED4JM;EC1JN;;;;;;IAMA,eAAA;ID4JM,mBAAA;IACI,cAAA;IC1JV,eAAA;ED8JE;EC5JF;;;;;;IDmKU,gBAAA;EC5JV;ED8JM;IACI,gBAAA;EC5JV;EACA;IDgKE,mBAAA;EC9JF;EACA;IDgKE,gBAAA;EC9JF;EACA;IDgKM,eAAA;IACI,kBAAA;IC9JV,OAAA;IDgKM,MAAA;IACI,mBAAA;EC9JV;EDgKU;IACI,QAAA;EC9Jd;EACA;IDkKU,QAAA;EChKV;EACA;IDkKc,oBAAA;EChKd;EDkKc;IACI,mBAAA;EChKlB;EDqKE;IACI,eAAA;ECnKN;EDqKM;IACI,eAAA;ICnKV,eAAA;EDqKU;ECnKV;IDqKc,eAAA;ECnKd;EACA;IACA,kBAAA;IDuKU,mBAAA;IACI,eAAA;ECrKd;EACA;IACA,eAAA;IDuKc,kBAAA;ECrKd;EACA;ID4KM,eAAA;IACI,eAAA;EC1KV;ED2KU;IACI,eAAA;ECzKd;ED4KM;IACI,kBAAA;EC1KV;EACA;ID4KU,eAAA;EC1KV;EACA;IACA,eAAA;EDkLM;EChLN;IACA,6BAAA;IDkLU,gBAAA;EChLV;EACA;IDkLU,oBAAA;EChLV;EACA;IACA,mBAAA;EDoLE;EClLF;IACA,eAAA;EDqLM;ECnLN;IACA,eAAA;EDqLM;ECnLN;IACA,eAAA;IDqLU,UAAA;ECnLV;EACA;IDqLU,mBAAA;IACI,oBAAA;IACA,eAAA;ECnLd;EDuLU;IACI,gBAAA;ECrLd;ED2LM;IACI,mBAAA;ECzLV;ED8LM;IACI,eAAA;EC5LV;ED8LM;IACI,aAAA;IC5LV,YAAA;ID8LU,kBAAA;IACI,eAAA;EC5Ld;ED8LU;IACI,mBAAA;IACA,oBAAA;IC5Ld,eAAA;ED+Lc;EC7Ld;IACA,gBAAA;ED+Lc;EC7Ld;ID+LkB,kBAAA;EC7LlB;EACA;ID+LkB,aAAA;EC7LlB;EDmME;IAEQ,mBAAA;IACA,2BAAA;EClMV;EDoMM;IACI,eAAA;IClMV,gBAAA;EDoMM;EClMN;IDoMU,aAAA;EClMV;EDqMU;IACI,eAAA;ECnMd;EDwME;IACI,iBAAA;IACA,eAAA;ECtMN;EDyMU;IACI,oBAAA;ECvMd;ED0MkB;IACI,SAAA;ECxMtB;EACA;ID0MkB,oBAAA;ECxMlB;EACA;;IDgNM,aAAA;EC7MN;EACA;IDgNU,eAAA;IACI,gBAAA;EC9Md;EDmNE;;IAGQ,SAAA;EClNV;EACA;IDsNU,qBAAA;ECpNV;EACA;IACA,WAAA;EDuNc;ECrNd;IDuNkB,aAAA;ECrNlB;EACA;IDuNkB,eAAA;ECrNlB;EACA;IDyNc,eAAA;IACI,iBAAA;ECvNlB;EACA;IDyNkB,YAAA;ECvNlB;EACA;IDyNkB,kBAAA;ICvNlB,YAAA;ID8NM,cAAA;IACI,WAAA;IACA,gBAAA;EC5NV;ED8NM;IACI,kBAAA;IACA,qBAAA;EC5NV;EDgOE;IACI,eAAA;EC9NN;EACA;IDiOU,gBAAA;IACI,eAAA;EC/Nd;EACA;IDmOE,eAAA;ECjOF;EACA;IACA,YAAA;IDmOM,yBAAA;ECjON;EACA;IACA,kBAAA;EDqOE;ECnOF;IACA,YAAA;IDsOU,eAAA;ECpOV;EACA;IDyOsB,YAAA;ECvOtB;EACA;IDgPM,YAAA;IACI,yBAAA;EC9OV;EACA;IDgPM,eAAA;EC9ON;EACA;IACA,YAAA;IDgPU,kBAAA;IACI,qBAAA;EC9Od;EACA;IDgPU,eAAA;IACI,iBAAA;EC9Od;EDmPE;IACI,eAAA;ICjPN,YAAA;IDoPU,aAAA;IACI,iBAAA;IACA,iBAAA;IClPd,kBAAA;EDwPM;ECtPN;IACA,kBAAA;ID0Pc,QAAA;IACI,MAAA;ICxPlB,WAAA;ID4P0B,mBAAA;IACI,gBAAA;IC1P9B,eAAA;ED8PkB;EC5PlB;ID8PsB,gBAAA;IACA,iBAAA;EC5PtB;EACA;IDmQE,mBAAA;IACI,eAAA;ECjQN;EDmQM;IACI,iBAAA;ICjQV,UAAA;EDoQE;EClQF;IACA,4BAAA;IDoQE,eAAA;EClQF;EACA;IDoQE,iBAAA;IACI,UAAA;EClQN;EACA;IDqQE,eAAA;IACI,mBAAA;ECnQN;EDqQE;IACI,gBAAA;ECnQN;EDqQM;IACI,eAAA;ECnQV;EACA;IDqQM,eAAA;ECnQN;EACA;IDqQM,eAAA;IACI,iBAAA;ECnQV;EDsQE;;ICnQF,4BAAA;IDsQM,iBAAA;ECpQN;EACA;;IDyQM,UAAA;IACA,QAAA;ECtQN;EDwQU;;IAEI,eAAA;ECtQd;ED0QE;IACI,kBAAA;ECxQN;ED2QE;IACI,kBAAA;ICzQN,gBAAA;ED0QM;ECxQN;;IAEA,eAAA;ED6QU;EC3QV;;IDkRM,kBAAA;EC/QN;EACA;;IDkRU,eAAA;EC/QV;EDkRE;;IC/QF,kBAAA;IDoRM,QAAA;IACI,MAAA;IClRV,gBAAA;EDsRE;ECpRF;IACA,mBAAA;EDqRM;ECnRN;IACA,eAAA;EACF;EDuRA;IAGY,aAAA;ECvRV;EACA;IACF,eAAA;ED4RA;EAGY;IACI,gBAAA;IACA,kBAAA;EC5Rd;EDgSE;IACI,iBAAA;EC9RN;EACA;IACF,mBAAA;EDiSA;EACI;IACI,eAAA;IC/RN,mBAAA;EDgSM;EC9RN;IACA,eAAA;ED+RU;EC7RV;IACA,eAAA;EDiSE;EC/RF;IACA,gBAAA;EDmSU;ECjSV;IACA,mBAAA;EDqSE;ECnSF;IDsSU,uBAAA;ICpSV,6BAAA;EDuSE;ECrSF;IACA,eAAA;IDuSU,kBAAA;ECrSV;EACA;IDySE,aAAA;ECvSF;EACA;IDySE,kBAAA;ECvSF;EACA;IDwSM,kBAAA;IACI,gBAAA;ECtSV;EACA;ID0SM,gBAAA;ECxSN;EACA;ID0SM,wBAAA;ECxSN;EACA;;;;;ID8SU,+BAAA;ECxSV;EACA;ID0SM,aAAA;ECxSN;EACA;ID6SM,eAAA;EC3SN;EACA;ID8SU,QAAA;EC5SV;AACF;AACA;EACE;IDkTU,aAAA;EChTV;AACF;AACA;EACE;IACA,UAAA;IDkTM,qBAAA;EChTN;EACA;IDkTM,gBAAA;IACI,WAAA;EChTV;AACF;AACA;EACE;IACA,wBAAA;EDmTU;ECjTV;IACA,iBAAA;EDoTM;EClTN;IACA,cAAA;EDwTU;ECtTV;IDwTc,eAAA;ECtTd;EDwTc;IACI,uBAAA;ECtTlB;EACA;IDwTkB,gBAAA;ECtTlB;EDyTkB;IACI,iBAAA;IACA,oBAAA;ECvTtB;ED2TkB;IACI,YAAA;ECzTtB;EACA;ID6TkB,eAAA;EC3TlB;EACA;IACA,kBAAA;EDkUE;EChUF;IACA,kBAAA;EDsUc;ECpUd;IACA,kBAAA;ID2UM,gBAAA;ECzUN;EACA;ID2UM,eAAA;ECzUN;EACA;IACA,eAAA;ED6UE;EC3UF;IACA,2BAAA;ID6UM,4BAAA;IACI,UAAA;IACA,iBAAA;IACA,2BAAA;EC3UV;ED6UM;IACI,iBAAA;EC3UV;ED6UM;IACI,qBAAA;EC3UV;EACA;IACA,sBAAA;EDgVM;EC9UN;IACA,YAAA;IDgVU,kBAAA;IACI,qBAAA;EC9Ud;EDgVU;IACI,kBAAA;EC9Ud;EDmVE;IAEQ,aAAA;EClVV;EACA;IDoVU,eAAA;EClVV;EDqVE;IACI,eAAA;IACA,gBAAA;ECnVN;EACA;IDsVU,eAAA;ECpVV;EDsVM;IACI,aAAA;ECpVV;EACA;IDsVU,cAAA;IACI,eAAA;ECpVd;EDuVM;IACI,eAAA;IACA,YAAA;IAEI,iBAAA;IACA,iBAAA;ECtVd;EDwVU;IACI,YAAA;IACA,iBAAA;ECtVd;EACA;IDwVU,YAAA;IACI,iBAAA;ECtVd;EACA;IDwVU,YAAA;IAEQ,iBAAA;ECvVlB;ED4VU;IACI,YAAA;EC1Vd;ED4Vc;IACI,cAAA;EC1VlB;EDiWM;IACI,eAAA;EC/VV;EDoWU;IACI,eAAA;IClWd,mBAAA;EDoWU;EClWV;IACA,gBAAA;EDoWU;EClWV;IACA,kBAAA;IDoWU,QAAA;IACI,MAAA;EClWd;EDoWU;IACI,aAAA;EClWd;EDoWU;IACI,SAAA;IClWd,WAAA;IDoWU,2BAAA;EClWV;EACA;IDoWU,mBAAA;EClWV;EACA;IDyWU,WAAA;ECvWV;EACA;ID6WU,YAAA;EC3WV;EACA;ID+WE,iBAAA;IACI,oBAAA;IC7WN,kBAAA;IDiXU,mBAAA;EC/WV;EACA;IDoXE,YAAA;IACI,mBAAA;IClXN,uBAAA;IDuXU,kBAAA;IACI,mBAAA;ECrXd;EDuXc;IACI,YAAA;ICrXlB,cAAA;ED8X0B;EC5X1B;ID8X8B,cAAA;EC5X9B;EACA;ID+X8B,kBAAA;IACI,UAAA;IC7XlC,eAAA;IDwYM,gBAAA;ECtYN;EACA;IDwYU,UAAA;IACI,mBAAA;IACA,gBAAA;ECtYd;EACA;IDwYc,eAAA;IACI,iBAAA;ECtYlB;ED2YkB;IACI,eAAA;ECzYtB;EACA;;ID6Y0B,SAAA;EC1Y1B;EACA;;IDoZc,gBAAA;ECjZd;EDmZc;IACI,eAAA;ECjZlB;EACA;IDsZE,QAAA;ECpZF;EACA;ID2ZsB,QAAA;ECzZtB;EACA;IDwakC,QAAA;ECtalC;EACA;IDwasC,QAAA;ECtatC;EACA;IDwasC,QAAA;ECtatC;EACA;IDmbM,QAAA;ECjbN;EACA;IDmbM,QAAA;ECjbN;EACA;IDobE,QAAA;EClbF;EACA;IACA,eAAA;EDobM;EClbN;IDobU,eAAA;EClbV;EDobM;IACI,oBAAA;EClbV;EACA;IDsbE,eAAA;ECpbF;EACA;;;;ID0bM,aAAA;ECrbN;EDubE;IACI,eAAA;ECrbN;EDubM;IACI,eAAA;ECrbV;EDubM;;;;;;;IASJ,oBAAA;IACI,gBAAA;ECvbN;EDybM;;;;;;;;IChbN,eAAA;ED6bM;EC3bN;ID6bU,oBAAA;EC3bV;ED6bU;IACI,eAAA;IC3bd,kBAAA;IDicM,YAAA;EC/bN;EACA;IDicM,eAAA;EC/bN;EACA;IDicM,mBAAA;EC/bN;EACA;;;;;;ID6cU,kBAAA;ICtcV,eAAA;EDwcU;ECtcV;IDwcc,WAAA;ECtcd;EDwcU;IACI,YAAA;ICtcd,UAAA;ED4cM;EC1cN;IACA,oBAAA;EDgdU;EC9cV;;;;;;IDydU,eAAA;ECldV;EACA;;;;;;;;;ID8dM,eAAA;IAEI,cAAA;IACA,eAAA;ICrdV,mBAAA;EDydE;ECvdF;;;;;;;;;IDueE,gBAAA;EC7dF;EACA;IDgeE,eAAA;EC9dF;EACA;IDgeM,eAAA;EC9dN;EACA;IDkeE,eAAA;IACI,kBAAA;ECheN;EDmeU;IACI,eAAA;ICjed,kBAAA;EDueM;ECreN;IDueU,gBAAA;ICreV,eAAA;EDyeE;ECveF;;;;KD4eU;ECveV;IDyeU,oBAAA;ECveV;EACA;IDyeM,mBAAA;ECveN;EACA;IACA,eAAA;EDyeM;ECveN;IDyeU,eAAA;ECveV;EDyeU;IACI,eAAA;ICved,UAAA;ED2eE;ECzeF;IACA,mBAAA;ED4eM;EC1eN;ID4eU,eAAA;EC1eV;ED6eE;IACI,aAAA;IC3eN,YAAA;ID8eE,kBAAA;IACI,eAAA;EC5eN;ED+eM;IACI,mBAAA;IC7eV,2BAAA;EDgfE;EC9eF;IACA,eAAA;EDofkB;EClflB;IDofsB,eAAA;EClftB;EACA;IDsfsB,eAAA;ECpftB;EACA;IACA,2BAAA;ID+fU,gBAAA;EC7fV;EACA;IACA,eAAA;EDigBE;EC/fF;IACA,oBAAA;EDigBE;EC/fF;IACA,gBAAA;IDigBE,eAAA;EC/fF;EACA;;IDigBU,aAAA;EC9fV;EACF;IDkgBA,qBAAA;EAEQ;ECjgBN;IACA,eAAA;EDkgBU;EChgBV;IACA,eAAA;EDsgBU;ECpgBV;IACA,kBAAA;ID4gBkB,qBAAA;EC1gBlB;EACA;IDihBM,eAAA;EC/gBN;EACA;IDihBM,eAAA;IACI,eAAA;EC/gBV;EACA;IACA,YAAA;IDohBU,kBAAA;IACI,qBAAA;EClhBd;EDuhBM;IACI,YAAA;ICrhBV,kBAAA;IDuhBM,qBAAA;ECrhBN;EACA;IACA,YAAA;IDuhBM,kBAAA;IACI,qBAAA;ECrhBV;EDuhBM;IACI,aAAA;ECrhBV;EDyhBM;IACI,aAAA;ECvhBV;EACA;IACA,eAAA;EDyhBM;ECvhBN;IDyhBU,gBAAA;ECvhBV;EDyhBM;IACI,eAAA;ECvhBV;EACA;;ID6hBc,eAAA;IC1hBd,mBAAA;ED8hBE;EC5hBF;IACA,mBAAA;ID8hBM,4BAAA;EC5hBN;EACA;IACA,WAAA;IDgiBM,YAAA;IAEQ,iBAAA;IACA,eAAA;EC/hBd;EDiiBU;IACI,eAAA;IC/hBd,mBAAA;EDmiBU;ECjiBV;IACA,kBAAA;IDsiBM,eAAA;ECpiBN;EACA;IDsiBM,gBAAA;ECpiBN;EACA;IDwiBM,gBAAA;ECtiBN;EACA;IACA,mBAAA;IDwiBU,eAAA;ECtiBV;EACA;ID2iBc,gBAAA;ECziBd;EACA;ID2iBkB,iBAAA;ECziBlB;EACA;ID8iBU,eAAA;EC5iBV;EACA;IDijBM,gBAAA;EC/iBN;EACA;IDijBU,eAAA;IACI;yBC/iBd;EDijBU;EC/iBV;;;IDsjBc,UAAA;IACI,QAAA;ECljBlB;EACA;IDojBkB,cAAA;ICljBlB,eAAA;EDyjBU;ECvjBV;IACA,mBAAA;ED4jBM;EC1jBN;IACA,oBAAA;ED4jBM;EC1jBN;IACA,eAAA;ED4jBM;EC1jBN;ID4jBU,QAAA;EC1jBV;AACF;AACA;EACE;ID8kBsB,cAAA;EC5kBtB;EACA;ID+kB8B,gBAAA;EC7kB9B;EACA;ID+kB0B,gBAAA;EC7kB1B;EACA;IDslBM,eAAA;ECplBN;EACA;IDslBM,eAAA;ECplBN;EACA;IDwlBM,eAAA;IACI,gBAAA;ICtlBV,gBAAA;EDwlBU;ECtlBV;IACA,eAAA;ED4lBU;EC1lBV;IACA,eAAA;ED4lBU;EC1lBV;IACA,eAAA;IDgmBU,mBAAA;EC9lBV;EACA;IDomBU,mBAAA;EClmBV;EACA;ID0mBc,gBAAA;ECxmBd;EACA;IACA,UAAA;IDgnBU,WAAA;IACI,YAAA;EC9mBd;EDonBM;IACI,OAAA;IClnBV,cAAA;EDqnBE;ECnnBF;IDqnBM,SAAA;ICnnBN,2BAAA;EDunBM;ECrnBN;IACA,WAAA;EDunBM;ECrnBN;IDunBU,aAAA;ECrnBV;EDwnBc;IACI,eAAA;IACA,mBAAA;ECtnBlB;EDynBc;IACI,kBAAA;ICvnBlB,mBAAA;ED2nBU;ECznBV;IACA,eAAA;ED2nBU;ECznBV;IACA,aAAA;ED2nBU;ECznBV;IACA,eAAA;EACF;ED8nBA;IACI,eAAA;EC5nBF;EACA;ID+nBE,YAAA;IACI,UAAA;EC7nBN;EDioBM;IACI,eAAA;EC/nBV;EACF;IDmoBA,WAAA;IAIY,YAAA;IACI,iBAAA;IACA,eAAA;ECpoBd;EACA;;IDuoBc,YAAA;ECpoBd;EDsoBU;IACI,aAAA;ECpoBd;EACA;IDsoBc,eAAA;ECpoBd;EACA;IDsoBc,eAAA;IACI,eAAA;ECpoBlB;EDsoBc;IACI,WAAA;ICpoBlB,YAAA;IDsoBc,iBAAA;IACI,eAAA;ECpoBlB;EDsoBc;IACI,eAAA;ECpoBlB;EDwoBc;IACI,eAAA;ECtoBlB;EDuoBkB;IACI,eAAA;ECroBtB;EACA;IDuoBkB,2BAAA;IACI,0BAAA;ECroBtB;EACA;;;;;;;ID6oB0B,eAAA;ECroB1B;EACA;;;;;;ID4oB8B,eAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;ECroB9B;EACA;;;;;;IAMA,gBAAA;EACF;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,UAAU;IACV,cAAc;IACd,oCAAoC;EACtC;EACA;IACE,yDAAyQ;EAC3Q;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":["@media only screen and (max-width: 767px) {\n  .elkevent-nav {\n    padding-top: 5px;\n    .navbar-brand {\n      img {\n        max-width: 100px;\n      }\n    }\n  }\n  .ptb-120 {\n    padding: {\n      top: 60px;\n      bottom: 60px;\n    }\n  }\n\n  .section-title {\n    margin-bottom: 30px;\n\n    span {\n      font-size: 13px;\n    }\n    h2 {\n      font-size: 25px;\n    }\n    .btn {\n      display: none;\n    }\n    .bg-title {\n      font-size: 60px !important;\n      left: auto;\n      right: 0;\n      transform: unset !important;\n    }\n  }\n\n  p {\n    font-size: 14px;\n  }\n  .btn {\n    font-size: 14px;\n    padding: 13px 24px;\n  }\n\n  .preloader {\n    .loader {\n      margin: -80px 0 0 -55px;\n    }\n  }\n\n  .main-banner {\n    height: 100%;\n    padding: {\n      top: 150px;\n      bottom: 100px;\n    }\n  }\n  .main-banner-content {\n    text-align: center;\n    &::before {\n      display: none;\n    }\n    h1 {\n      font-size: 28px;\n      line-height: 1.5;\n      font-weight: 800;\n\n      br {\n        display: none;\n      }\n    }\n    p {\n      font-size: 15px;\n    }\n    ul {\n      margin: 20px 0 30px;\n      li {\n        font-size: 15px;\n        margin-top: 4px;\n        margin-bottom: 4px;\n      }\n    }\n    .button-box {\n      .video-btn {\n        margin: {\n          left: 15px;\n          top: 25px;\n        }\n      }\n    }\n    &.banner-content-center {\n      margin: 0 auto 0;\n      text-align: center;\n    }\n  }\n  .event-countdown {\n    right: 0;\n    left: 0;\n    margin: 50px auto 0;\n    text-align: center;\n    position: inherit;\n\n    #timer {\n      div {\n        font-size: 30px;\n        margin: 0 20px 0 0;\n        position: relative;\n        &:last-child {\n          margin-right: 0;\n        }\n        &:first-child {\n          margin-left: 0;\n        }\n\n        span {\n          margin-top: 0;\n          font-size: 12px;\n          position: relative;\n          right: 0;\n          top: 0;\n          transform: unset;\n          margin-top: -5px;\n          letter-spacing: 1px;\n        }\n        &#hours {\n          span {\n            right: 0;\n            margin-top: -5px;\n          }\n        }\n        &#minutes {\n          span {\n            right: 0;\n            margin-top: -5px;\n          }\n        }\n        &#seconds {\n          span {\n            right: 0;\n            margin-top: -5px;\n          }\n        }\n      }\n    }\n  }\n  .shape1,\n  .shape2,\n  .shape3,\n  .shape4 {\n    display: none;\n  }\n  .slideshow-banner {\n    .event-countdown {\n      text-align: center;\n      margin: {\n        left: 0;\n        top: 0;\n        bottom: 25px;\n      }\n      #timer {\n        div {\n          font-size: 30px;\n          margin: 0 22px 0 0;\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n  }\n  .home-slides {\n    .swiper-button-next,\n    .swiper-button-prev {\n      width: 35px;\n      height: 35px;\n      line-height: 35px;\n      top: auto;\n      bottom: 10px;\n\n      &::after {\n        font: {\n          size: 20px;\n        }\n      }\n    }\n  }\n\n  .about-content {\n    span {\n      font-size: 13px;\n    }\n    h2 {\n      font-size: 25px;\n      margin-bottom: 15px;\n    }\n    h6 {\n      font-size: 15px;\n    }\n  }\n  .about-image {\n    margin-top: 40px;\n\n    .about-img1 {\n      right: 0;\n      top: 0;\n      width: 100%;\n    }\n    .about-img2 {\n      position: relative;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      margin-top: 20px;\n    }\n    .shape-img {\n      top: 27%;\n      left: 0;\n      right: 0;\n      margin: 0 auto;\n    }\n    .btn {\n      bottom: 0;\n      right: 15px;\n      transform: unset !important;\n    }\n  }\n  .about-area-two {\n    .about-content {\n      .signature {\n        margin-bottom: 0;\n      }\n    }\n  }\n  .about-area-three {\n    .about-content {\n      .signature {\n        margin-bottom: 0;\n      }\n    }\n    .about-image {\n      margin: {\n        top: 0;\n        bottom: 30px;\n      }\n      .about-img1 {\n        margin-top: 0;\n      }\n      .btn {\n        left: auto;\n        bottom: 30px;\n        right: 15px;\n      }\n    }\n  }\n\n  .countdown-area {\n    .event-countdown {\n      margin: 0;\n\n      #timer {\n        overflow: hidden;\n        margin: 0 -10px;\n        text-align: center;\n\n        div {\n          margin: 0;\n          text-align: center;\n          padding: 0 10px;\n        }\n      }\n    }\n  }\n\n  .why-choose-us {\n    padding: {\n      top: 60px;\n      bottom: 35px;\n      left: 15px;\n      right: 15px;\n    }\n    &::before {\n      opacity: 0.8;\n    }\n  }\n  .single-box {\n    height: 100%;\n    margin-bottom: 30px;\n    padding: {\n      left: 15px;\n      right: 15px;\n    }\n    border: none !important;\n\n    .d-table {\n      height: auto;\n      display: block;\n\n      &-cell {\n        display: block;\n      }\n    }\n    .content {\n      position: relative;\n      padding: {\n        left: 0;\n        right: 0;\n      }\n      .btn {\n        opacity: 1;\n        visibility: visible;\n        margin-top: 20px;\n      }\n      .icon {\n        font-size: 35px;\n      }\n      h3 {\n        font: {\n          size: 20px;\n        }\n      }\n    }\n    &:hover,\n    &:focus {\n      .content {\n        bottom: 0;\n\n        p {\n          margin-bottom: 0;\n        }\n      }\n    }\n    &::before {\n      display: none;\n    }\n  }\n  .why-choose-content {\n    padding: 35px 25px;\n\n    h3 {\n      font-size: 20px;\n      margin-bottom: 15px;\n    }\n    span {\n      margin: 0 auto 0;\n      font-size: 60px;\n    }\n  }\n\n  .single-speakers {\n    .speakers-content {\n      bottom: 20px;\n      left: 20px;\n      text-align: center;\n      width: 100%;\n\n      h3 {\n        font-size: 18px;\n        margin-bottom: 0;\n      }\n      span {\n        font-size: 14px;\n      }\n    }\n    &:hover,\n    &:focus {\n      .speakers-content {\n        bottom: 20px;\n      }\n    }\n    ul {\n      padding: 10px;\n\n      li {\n        a {\n          width: 35px;\n          height: 35px;\n          line-height: 35px;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n  .elkevent-single-speakers {\n    .speakers-content {\n      h3 {\n        font-size: 18px;\n      }\n      span {\n        font-size: 14px;\n      }\n    }\n  }\n  .speakers-area-two {\n    padding-bottom: 30px;\n  }\n  .single-speakers-box {\n    .speakers-content {\n      h3 {\n        font-size: 20px;\n      }\n      span {\n        font-size: 13px;\n      }\n    }\n  }\n\n  .event-tabs {\n    .react-tabs__tab-list {\n      display: block;\n      margin-bottom: 0;\n\n      li {\n        &::before {\n          display: none;\n        }\n        display: block;\n        font-size: 17px;\n        padding: 20px 10px;\n\n        span {\n          font-size: 12px;\n        }\n      }\n    }\n\n    .react-tabs__tab-panel {\n      padding: {\n        left: 10px;\n        right: 10px;\n        bottom: 10px;\n        top: 10px;\n      }\n      .accordion {\n        .accordion__item {\n          padding: {\n            left: 15px;\n            right: 15px;\n            bottom: 20px;\n            top: 20px;\n          }\n\n          .accordion__button {\n            display: block;\n            padding-left: 0;\n            padding-right: 0;\n            padding-bottom: 25px;\n            padding-top: 0;\n            text-align: center;\n\n            .author {\n              margin: {\n                right: auto;\n                bottom: 15px;\n                left: auto;\n              }\n              position: relative;\n              top: 0;\n              transform: unset;\n              right: 0;\n            }\n            .schedule-info {\n              h3 {\n                font-size: 18px;\n                margin-bottom: 10px;\n                line-height: 28px;\n              }\n              ul {\n                li {\n                  margin: {\n                    right: 0;\n                    bottom: 10px;\n                  }\n                  display: block;\n                  font-size: 14px;\n\n                  &:last-child {\n                    margin-bottom: 0;\n                  }\n                }\n              }\n            }\n          }\n        }\n        .accordion__panel {\n          padding: 0;\n          p {\n            font-size: 14px;\n            margin-bottom: 20px;\n          }\n          .row {\n            .text-right {\n              text-align: left !important;\n              margin-top: 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .schedule-slides-item {\n    .single-schedule {\n      padding: 0 0 0 0;\n\n      .schedule-date {\n        font-size: 20px;\n        padding: 25px;\n        position: relative;\n        width: auto;\n\n        span {\n          font-size: 14px;\n        }\n      }\n      .schedule-content {\n        display: block;\n        text-align: center;\n\n        .author {\n          margin: {\n            right: auto;\n            bottom: 15px;\n            left: auto;\n          }\n        }\n        .schedule-info {\n          h3 {\n            font-size: 17px;\n            margin-bottom: 12px;\n            line-height: 28px;\n          }\n          ul {\n            li {\n              margin: {\n                right: 0;\n                bottom: 10px;\n              }\n              display: block;\n              font-size: 14px;\n\n              &:last-child {\n                margin-bottom: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .schedule-style-three {\n    padding-bottom: 30px;\n  }\n  .single-schedule-item {\n    .schedule-date {\n      font-size: 20px;\n      padding: 25px;\n      position: relative;\n      width: auto;\n\n      span {\n        font-size: 14px;\n      }\n    }\n    .schedule-item-wrapper {\n      .schedule-content {\n        display: block;\n        text-align: center;\n\n        .author {\n          margin: {\n            right: auto;\n            bottom: 15px;\n            left: auto;\n          }\n        }\n        .schedule-info {\n          h3 {\n            font-size: 18px;\n            margin-bottom: 12px;\n            line-height: 28px;\n          }\n          ul {\n            li {\n              margin: {\n                right: 0;\n                bottom: 10px;\n              }\n              display: block;\n              font-size: 14px;\n\n              &:last-child {\n                margin-bottom: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .btn-box {\n    margin-top: 20px;\n\n    .btn {\n      margin: 20px 10px 0;\n    }\n  }\n  .schedule-slides {\n    &.owl-theme {\n      .owl-nav {\n        margin-top: 30px;\n\n        [class*=\"owl-\"] {\n          font-size: 25px;\n          position: relative;\n          left: 0;\n          top: 0;\n          right: 0 !important;\n        }\n      }\n    }\n  }\n  .schedule-style-four {\n    .col-lg-8 {\n      order: 2;\n    }\n    .col-lg-4 {\n      order: 1;\n    }\n  }\n\n  .funfacts-area {\n    padding-bottom: 30px;\n  }\n  .single-funfact {\n    margin-bottom: 30px;\n\n    .icon {\n      font-size: 30px;\n    }\n    h3 {\n      font-size: 35px;\n      margin-top: 8px;\n    }\n    p {\n      font-size: 13px;\n    }\n  }\n  .funFact {\n    text-align: center;\n    margin-bottom: 35px;\n    padding-left: 0;\n\n    .icon {\n      font-size: 30px;\n      position: relative;\n    }\n    h3 {\n      font-size: 35px;\n      margin-top: 8px;\n    }\n    p {\n      font-size: 14px;\n    }\n  }\n\n  .cta-area {\n    text-align: center;\n\n    span {\n      font-size: 15px;\n    }\n    h3 {\n      font-size: 24px;\n    }\n    .text-right {\n      text-align: center !important;\n      margin-top: 25px;\n    }\n  }\n\n  .pricing-area {\n    padding-bottom: 30px;\n  }\n  .pricing-table-box {\n    margin-bottom: 30px;\n\n    .title {\n      font-size: 17px;\n    }\n    .price-value {\n      font-size: 35px;\n\n      sup {\n        font-size: 20px;\n        top: -18px;\n      }\n    }\n    .pricing-content {\n      li {\n        margin-bottom: 10px;\n        padding-bottom: 10px;\n        font-size: 14px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n  .pricing-plan {\n    margin-bottom: 30px;\n\n    h3 {\n      font-size: 20px;\n\n      span {\n        height: 130px;\n        width: 130px;\n        line-height: 135px;\n        font-size: 25px;\n      }\n    }\n    .pricing-content {\n      li {\n        margin-bottom: 10px;\n        padding-bottom: 10px;\n        font-size: 14px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n\n  .partner-area {\n    .section-title {\n      text-align: center;\n      .bar {\n        display: none;\n      }\n    }\n    .partner-title {\n      margin-bottom: 40px;\n      transform: unset !important;\n\n      h3 {\n        font: {\n          size: 18px;\n          weight: 600;\n        }\n      }\n    }\n  }\n\n  .single-blog-post {\n    .blog-post-content {\n      padding: 20px;\n\n      .date {\n        font-size: 13px;\n      }\n      h3 {\n        line-height: 28px;\n        font-size: 18px;\n      }\n    }\n  }\n  .blog-section {\n    padding-bottom: 30px;\n  }\n  .single-blog-card {\n    .post-tag {\n      top: 15px;\n    }\n    .blog-post-content {\n      padding: 0 20px 20px;\n\n      p,\n      .read-more-btn {\n        display: none;\n      }\n      h3 {\n        font-size: 18px;\n        margin-bottom: 0;\n      }\n    }\n    &:hover,\n    &:focus {\n      .post-tag {\n        top: 15px;\n      }\n    }\n  }\n\n  .buy-tickets-area {\n    &.ptb-120 {\n      padding-bottom: 140px;\n    }\n  }\n\n  .subscribe-area {\n    &::before {\n      height: 74%;\n    }\n    .subscribe-inner {\n      padding: 20px;\n\n      span {\n        font-size: 13px;\n      }\n      h2 {\n        font-size: 25px;\n        line-height: 36px;\n      }\n      .newsletter-form {\n        .form-control {\n          height: 50px;\n        }\n        .btn {\n          position: relative;\n          height: 54px;\n          display: block;\n          width: 100%;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  .page-title-area {\n    padding: {\n      top: 160px;\n      bottom: 100px;\n    }\n    h1 {\n      font-size: 28px;\n    }\n    span {\n      margin-top: 10px;\n      font-size: 15px;\n    }\n    ul {\n      li {\n        font-size: 15px;\n      }\n    }\n  }\n\n  .login-area {\n    height: 100%;\n    padding: 120px 15px 120px;\n\n    .login-form {\n      p {\n        text-align: center;\n\n        a {\n          &.pull-right {\n            float: unset;\n            margin-top: 5px;\n          }\n          &.pull-left {\n            float: unset;\n          }\n        }\n      }\n    }\n  }\n\n  .signup-area {\n    height: 100%;\n    padding: 120px 15px 120px;\n\n    .signup-form {\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .coming-soon {\n    height: 100%;\n    padding: {\n      top: 100px;\n      bottom: 100px;\n    }\n\n    .coming-soon-content {\n      h1 {\n        font-size: 30px;\n        line-height: 45px;\n      }\n      #timer {\n        div {\n          font-size: 40px;\n          width: 120px;\n          height: 120px;\n          padding-top: 27px;\n          line-height: 39px;\n          margin: 0 5px 15px;\n        }\n      }\n      form {\n        button {\n          position: relative;\n          right: 0;\n          top: 0;\n          width: 100%;\n          border-radius: 30px;\n          margin-top: 10px;\n          padding: 13px 0;\n        }\n      }\n    }\n  }\n\n  .error-area {\n    h1 {\n      font-size: 110px;\n      line-height: 85px;\n    }\n    h3 {\n      margin: 30px 0 15px;\n      font-size: 20px;\n    }\n  }\n\n  .faq-accordion {\n    box-shadow: unset;\n    padding: 0;\n\n    .accordion {\n      .accordion-title {\n        padding: 10px 10px 10px 50px;\n        font-size: 14px;\n      }\n    }\n  }\n  .faq-contact {\n    box-shadow: unset;\n    padding: 0;\n\n    h3 {\n      font-size: 20px;\n      margin-bottom: 25px;\n    }\n  }\n\n  .sidebar {\n    margin-top: 50px;\n\n    .widget {\n      .widget-title {\n        font-size: 18px;\n      }\n      &.widget_recent_entries {\n        ul {\n          li {\n            h5 {\n              font-size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .blog-details {\n    h3 {\n      font-size: 20px;\n      line-height: 30px;\n    }\n    blockquote,\n    .blockquote {\n      padding: 88px 20px 20px 20px;\n      border-width: 3px;\n\n      &::before {\n        left: 20px;\n        top: 20%;\n      }\n      p {\n        font-size: 15px;\n      }\n    }\n  }\n\n  .post-tag-media {\n    text-align: center;\n\n    ul {\n      &.social-share {\n        text-align: center;\n        margin-top: 15px;\n      }\n    }\n  }\n\n  .comments-area {\n    .comments-title,\n    .comment-reply-title {\n      font-size: 20px;\n    }\n    ol,\n    ul {\n      li {\n        .comment-body {\n          padding: 20px 15px;\n\n          .comment-meta {\n            .comment-author {\n              .fn {\n                font-size: 16px;\n              }\n            }\n          }\n          .reply {\n            position: relative;\n            right: 0;\n            top: 0;\n            margin-top: 20px;\n          }\n        }\n      }\n    }\n  }\n\n  .contact-box {\n    margin-bottom: 30px;\n\n    h4 {\n      font-size: 18px;\n    }\n  }\n  .contact-form {\n    margin-top: 0;\n  }\n  .leave-your-message h3 {\n    font-size: 18px;\n  }\n  #contactForm {\n    margin-top: 30px;\n    padding: 20px 15px;\n  }\n\n  .footer-area {\n    padding-top: 60px;\n  }\n  .single-footer-widget {\n    margin-bottom: 30px;\n\n    h3 {\n      font-size: 20px;\n      margin-bottom: 15px;\n    }\n    span {\n      font-size: 14px;\n    }\n    a {\n      font-size: 14px;\n    }\n  }\n  .copyright-area {\n    margin-top: 20px;\n\n    ul {\n      margin: 25px 0 18px;\n    }\n  }\n\n  .countdown1 {\n    position: initial;\n    text-align: center !important;\n    #timer {\n      div {\n        font-size: 30px;\n        margin: 0 20px 0 0;\n      }\n    }\n  }\n  .blog-slides.owl-theme .owl-nav.disabled + .owl-dots {\n    margin-top: 0;\n  }\n\n  .buy-tickets {\n    text-align: center;\n    .buy-ticket-btn {\n      text-align: center;\n      margin-top: 30px;\n    }\n  }\n  .copyright-area {\n    .logo {\n      img {\n        max-width: 100px;\n      }\n    }\n  }\n\n  .speakers-area {\n    .p-0 {\n      padding: 0 15px !important;\n    }\n    .single-speakers,\n    .elkevent-single-speakers {\n      margin-bottom: 30px;\n    }\n  }\n  section.speakers-area.ptb-120.pb-0 {\n    padding-bottom: 30px !important;\n  }\n\n  .slideshow-banner {\n    .main-banner-content {\n      margin-top: 0;\n    }\n  }\n\n  .modal-video-body {\n    padding: 0 20px;\n    .modal-video-close-btn {\n      right: 0;\n    }\n  }\n}\n\n@media only screen and (min-width: 423px) and (max-width: 767px) {\n  .main-banner-content {\n    .button-box {\n      .video-btn {\n        margin-top: 0;\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .schedule-area {\n    .tabs {\n      li {\n        width: 50%;\n        display: inline-block;\n      }\n    }\n  }\n  .why-choose-us-two {\n    max-width: 540px;\n    width: 100%;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .elkevent-nav {\n    padding-top: 10px;\n    .navbar-brand {\n      padding-top: 0;\n      img {\n        max-width: 90px;\n      }\n    }\n  }\n  .countdown1 {\n    bottom: 25px !important;\n  }\n  .copyright-area {\n    .logo {\n      img {\n        max-width: 100px;\n      }\n    }\n  }\n  .ptb-120 {\n    padding: {\n      top: 80px;\n      bottom: 80px;\n    }\n  }\n  .event-countdown {\n    bottom: 15px;\n    #timer {\n      span {\n        font-size: 12px;\n      }\n    }\n  }\n  .slideshow-banner .event-countdown {\n    text-align: center;\n  }\n  .buy-tickets {\n    text-align: center;\n    .buy-ticket-btn {\n      text-align: center;\n      margin-top: 30px;\n    }\n  }\n  .section-title {\n    span {\n      font-size: 14px;\n    }\n    h2 {\n      font-size: 30px;\n    }\n    .bg-title {\n      font-size: 100px;\n      line-height: 120%;\n      right: 20%;\n      margin-top: -10px;\n      transform: unset !important;\n    }\n    .btn {\n      margin-top: -25px;\n    }\n  }\n\n  .elkevent-mobile-nav {\n    .logo {\n      left: 40px !important;\n    }\n    &.mean-container a {\n      &.meanmenu-reveal {\n        padding: 12px 40px 0 0;\n      }\n    }\n  }\n\n  .main-banner {\n    height: 100%;\n    padding: {\n      top: 200px;\n      bottom: 200px;\n    }\n  }\n  .main-banner-content {\n    text-align: center;\n    &::before {\n      display: none;\n    }\n    p {\n      font-size: 18px;\n    }\n    h1 {\n      font-size: 40px;\n      line-height: 1.4;\n    }\n    ul {\n      li {\n        font-size: 15px;\n      }\n    }\n    &.banner-content-center {\n      margin-top: 0;\n    }\n  }\n\n  .event-countdown {\n    #timer {\n      div {\n        margin: 0 25px;\n        font-size: 50px;\n\n        span {\n          font-size: 13px;\n          right: -30px;\n          margin-top: -11px;\n          letter-spacing: 0;\n        }\n        &#hours {\n          span {\n            right: -36px;\n            margin-top: -10px;\n          }\n        }\n        &#minutes {\n          span {\n            right: -42px;\n            margin-top: -10px;\n          }\n        }\n        &#seconds {\n          span {\n            right: -44px;\n            margin-top: -10px;\n          }\n        }\n      }\n    }\n  }\n\n  .subscribe-area .subscribe-inner .newsletter-form .btn {\n    height: 50px;\n  }\n\n  .countdown-area {\n    .event-countdown {\n      #timer {\n        div {\n          margin: 0 30px;\n        }\n      }\n    }\n  }\n\n  .about-content {\n    span {\n      font-size: 14px;\n    }\n    h2 {\n      font-size: 30px;\n      margin-bottom: 20px;\n    }\n  }\n\n  .about-image {\n    margin-top: 50px;\n\n    .about-img1 {\n      position: relative;\n      right: 0;\n      top: 0;\n    }\n    .about-img2 {\n      display: none;\n    }\n    .btn {\n      bottom: 0;\n      right: 25px;\n      transform: unset !important;\n    }\n  }\n\n  .about-area-three {\n    .about-image {\n      margin-bottom: 30px;\n\n      .about-img1 {\n        width: 100%;\n      }\n      .btn {\n        bottom: 30px;\n      }\n    }\n  }\n\n  .why-choose-us {\n    padding: {\n      top: 80px;\n      bottom: 50px;\n      left: 15px;\n      right: 15px;\n    }\n  }\n  .single-box {\n    height: 100%;\n    margin-bottom: 30px;\n    border: none !important;\n    padding: {\n      left: 15px;\n      right: 15px;\n    }\n    .d-table {\n      height: auto;\n      display: block;\n\n      &-cell {\n        display: block;\n      }\n    }\n    .content {\n      position: relative;\n      z-index: 2;\n      padding: {\n        left: 0;\n        right: 0;\n      }\n      .btn {\n        opacity: 1;\n        visibility: visible;\n        margin-top: 20px;\n      }\n      .icon {\n        font-size: 35px;\n        line-height: 40px;\n      }\n      h3 {\n        font: {\n          size: 22px;\n        }\n      }\n    }\n    &:hover,\n    &:focus {\n      .content {\n        bottom: 0;\n\n        p {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n\n  .why-choose-content {\n    h3 {\n      font-size: 22px;\n    }\n  }\n  .why-choose-us-two {\n    .col-lg-4 {\n      &:nth-child(1) {\n        order: 1;\n      }\n      &:nth-child(2) {\n        order: 2;\n      }\n      &:nth-child(3) {\n        order: 4;\n      }\n      &:nth-child(4) {\n        order: 3;\n      }\n      &:nth-child(5) {\n        order: 5;\n      }\n      &:nth-child(6) {\n        order: 6;\n      }\n      &:nth-child(7) {\n        order: 7;\n      }\n      &:nth-child(8) {\n        order: 8;\n      }\n    }\n  }\n\n  .single-speakers {\n    .speakers-content {\n      h3 {\n        font-size: 22px;\n      }\n    }\n  }\n  .elkevent-single-speakers {\n    .speakers-content {\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n  .speakers-area-two {\n    padding-bottom: 50px;\n  }\n  .single-speakers-box {\n    .speakers-content {\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .shape1,\n  .shape2,\n  .shape3,\n  .shape4 {\n    display: none;\n  }\n\n  .event-tabs {\n    .react-tabs__tab-list {\n      li {\n        font-size: 18px;\n\n        span {\n          font-size: 13px;\n        }\n      }\n    }\n    .accordion__panel {\n      .accordion {\n        .accordion__item {\n          .accordion__button {\n            .schedule-info {\n              h3 {\n                font-size: 18px;\n                padding-right: 115px;\n                line-height: 1.4;\n              }\n              ul {\n                li {\n                  font-size: 13px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .schedule-slides-item {\n    .single-schedule {\n      padding: 0 0 0 175px;\n\n      .schedule-date {\n        font-size: 22px;\n        padding: 20px 20px;\n        width: 175px;\n\n        span {\n          font-size: 14px;\n        }\n      }\n      .schedule-content {\n        .schedule-info {\n          h3 {\n            font-size: 18px;\n            margin-bottom: 10px;\n          }\n          ul {\n            li {\n              margin-right: 10px;\n              font-size: 13px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .schedule-slides.owl-theme {\n    .owl-nav {\n      [class*=\"owl-\"] {\n        left: -15px;\n\n        &.owl-next {\n          right: -15px;\n          left: auto;\n        }\n      }\n    }\n  }\n  .schedule-style-three {\n    padding-bottom: 50px;\n  }\n  .single-schedule-item {\n    .schedule-item-wrapper {\n      .schedule-content {\n        .schedule-info {\n          ul {\n            li {\n              font-size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .schedule-style-four {\n    .tab_content {\n      .tabs_item {\n        .accordion {\n          .accordion-item {\n            .accordion-title {\n              .schedule-info {\n                ul {\n                  li {\n                    font-size: 14px;\n                    display: block;\n                    margin-right: 0;\n                    margin-bottom: 10px;\n\n                    &:last-child {\n                      margin-bottom: 0;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .single-funfact {\n    .icon {\n      font-size: 35px;\n    }\n    h3 {\n      font-size: 40px;\n    }\n  }\n  .funFact {\n    padding-left: 0;\n    text-align: center;\n\n    .icon {\n      font-size: 35px;\n      position: relative;\n    }\n    h3 {\n      margin-top: 10px;\n      font-size: 40px;\n    }\n  }\n\n  .event-countdown {\n    right: 0;\n    text-align: center;\n    left: 0;\n  }\n\n  .pricing-area {\n    padding-bottom: 50px;\n  }\n  .pricing-table-box {\n    margin-bottom: 30px;\n\n    .title {\n      font-size: 22px;\n    }\n    .price-value {\n      font-size: 40px;\n\n      sup {\n        font-size: 20px;\n        top: -20px;\n      }\n    }\n  }\n  .pricing-plan {\n    margin-bottom: 30px;\n\n    h3 {\n      font-size: 22px;\n\n      span {\n        height: 140px;\n        width: 140px;\n        line-height: 145px;\n        font-size: 30px;\n      }\n    }\n  }\n\n  .partner-area {\n    .partner-title {\n      margin-bottom: 40px;\n      transform: unset !important;\n\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .cta-area {\n    span {\n      font-size: 16px;\n    }\n    h3 {\n      font-size: 30px;\n    }\n    .text-right {\n      text-align: left !important;\n      margin-top: 25px;\n    }\n  }\n\n  .single-blog-post {\n    .blog-post-content {\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n  .single-blog-card {\n    .blog-post-content {\n      padding: 0 20px 20px;\n\n      h3 {\n        margin-bottom: 0;\n        font-size: 20px;\n      }\n      p,\n      .read-more-btn {\n        display: none;\n      }\n    }\n  }\n\n  .buy-tickets-area {\n    &.ptb-120 {\n      padding-bottom: 175px;\n    }\n  }\n\n  .subscribe-area {\n    .subscribe-inner {\n      span {\n        font-size: 15px;\n      }\n      h2 {\n        font-size: 30px;\n      }\n    }\n  }\n\n  .page-title-area {\n    padding: {\n      top: 160px;\n      bottom: 120px;\n    }\n    h1 {\n      font-size: 30px;\n    }\n    span {\n      margin-top: 8px;\n      font-size: 16px;\n    }\n  }\n\n  .login-area {\n    height: 100%;\n    padding: {\n      top: 100px;\n      bottom: 100px;\n    }\n  }\n\n  .signup-area {\n    height: 100%;\n    padding: {\n      top: 100px;\n      bottom: 100px;\n    }\n  }\n\n  .coming-soon {\n    height: 100%;\n    padding: {\n      top: 100px;\n      bottom: 100px;\n    }\n  }\n\n  .faq-accordion {\n    padding: 30px;\n  }\n\n  .faq-contact {\n    padding: 30px;\n\n    h3 {\n      font-size: 22px;\n    }\n  }\n\n  .sidebar {\n    margin-top: 50px;\n\n    .widget {\n      .widget-title {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .comments-area {\n    .comments-title,\n    .comment-reply-title {\n      font-size: 20px;\n      margin-bottom: 25px;\n    }\n  }\n\n  .contact-box {\n    margin-bottom: 30px;\n    padding: 30px 20px 30px 75px;\n\n    .icon {\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n      font-size: 16px;\n    }\n    h4 {\n      font-size: 18px;\n      margin-bottom: 13px;\n    }\n    p {\n      margin-bottom: 3px;\n      font-size: 14px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n  .contact-form {\n    margin-top: 20px;\n  }\n  .leave-your-message {\n    h3 {\n      margin-bottom: 12px;\n      font-size: 20px;\n    }\n  }\n  #contactForm {\n    margin-top: 30px;\n  }\n\n  .footer-area {\n    padding-top: 80px;\n  }\n  .single-footer-widget {\n    h3 {\n      font-size: 22px;\n    }\n  }\n  .copyright-area {\n    margin-top: 60px;\n  }\n  .elkevent-nav {\n    nav {\n      .navbar-nav {\n        .nav-item {\n          a {\n            font-size: 15px;\n            margin-left: 11px;\n            margin-right: 11px;\n          }\n\n          &:nth-last-child(1),\n          &:nth-last-child(2),\n          &:nth-last-child(3) {\n            .dropdown-menu {\n              left: auto;\n              right: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .countdown1 {\n    #timer {\n      div {\n        margin: 0 20px;\n        font-size: 40px;\n      }\n    }\n  }\n  .single-funfact {\n    margin-bottom: 30px;\n  }\n  .funfacts-area.ptb-120 {\n    padding-bottom: 50px;\n  }\n  .modal-video-body {\n    padding: 0 30px;\n    .modal-video-close-btn {\n      right: 0;\n    }\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .elkevent-nav {\n    .navbar-brand {\n      padding-top: 0;\n      img {\n        max-width: 100px;\n      }\n    }\n  }\n  .copyright-area {\n    .logo {\n      img {\n        max-width: 100px;\n      }\n    }\n  }\n  .elkevent-nav {\n    nav {\n      .navbar-nav {\n        .nav-item {\n          a {\n            font-size: 15px;\n          }\n        }\n      }\n    }\n  }\n  .main-banner-content {\n    p {\n      font-size: 20px;\n    }\n    h1 {\n      font-size: 45px;\n      font-weight: 800;\n      line-height: 1.3;\n    }\n  }\n  .event-countdown {\n    #timer {\n      div {\n        font-size: 50px;\n      }\n    }\n  }\n  .about-content {\n    span {\n      font-size: 15px;\n    }\n    h2 {\n      font-size: 27px;\n      margin-bottom: 20px;\n    }\n    h6 {\n      margin-bottom: 15px;\n    }\n    .signature {\n      margin-top: 25px;\n    }\n  }\n  .about-image {\n    .about-img1 {\n      width: 85%;\n      top: -145px;\n      right: -40px;\n    }\n    .about-img2 {\n      left: 0;\n      bottom: -142px;\n    }\n    .btn {\n      bottom: 0;\n      transform: unset !important;\n    }\n  }\n  .about-area-three {\n    .about-image {\n      img {\n        width: 100%;\n      }\n    }\n  }\n  .why-choose-content {\n    padding: 10px;\n\n    h3 {\n      font-size: 22px;\n      margin-bottom: 10px;\n    }\n  }\n  .single-box {\n    .content {\n      padding: {\n        left: 10px;\n        right: 10px;\n      }\n      h3 {\n        font-size: 22px;\n      }\n    }\n    .content {\n      &::before {\n        display: none;\n      }\n    }\n  }\n  .cta-area {\n    h3 {\n      font-size: 30px;\n    }\n    span {\n      font-size: 15px;\n    }\n  }\n  .single-speakers {\n    .speakers-content {\n      bottom: 15px;\n      left: 15px;\n\n      h3 {\n        font-size: 18px;\n      }\n    }\n    ul {\n      li {\n        a {\n          width: 35px;\n          height: 35px;\n          line-height: 35px;\n          font-size: 14px;\n        }\n      }\n    }\n    &:hover,\n    &:focus {\n      .speakers-content {\n        bottom: 12px;\n      }\n    }\n  }\n  .elkevent-single-speakers {\n    .speakers-content {\n      padding: 15px;\n\n      h3 {\n        font-size: 18px;\n      }\n      span {\n        font-size: 13px;\n        margin-top: 5px;\n      }\n    }\n    ul {\n      li {\n        a {\n          width: 35px;\n          height: 35px;\n          line-height: 35px;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n  .single-speakers-box {\n    .speakers-content {\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n  .section-title {\n    span {\n      font-size: 15px;\n    }\n    h2 {\n      font-size: 34px;\n    }\n    .bg-title {\n      transform: unset !important;\n      font-size: 80px;\n    }\n  }\n  .event-tabs {\n    .react-tabs__tab-panel {\n      .accordion {\n        .accordion__item {\n          .accordion__button {\n            .schedule-info {\n              h3 {\n                font-size: 20px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .single-schedule-item {\n    .schedule-item-wrapper {\n      .schedule-content {\n        .schedule-info {\n          ul {\n            li {\n              font-size: 14px;\n              display: block;\n              margin: {\n                right: 0;\n                bottom: 5px;\n              }\n              &:last-child {\n                margin-bottom: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .pricing-table-box {\n    .title {\n      font-size: 18px;\n    }\n    .price-value {\n      font-size: 40px;\n    }\n  }\n  .partner-area {\n    .partner-title {\n      transform: unset !important;\n\n      h3 {\n        font-size: 20px;\n      }\n    }\n  }\n  .subscribe-area {\n    .subscribe-inner {\n      span {\n        font-size: 15px;\n      }\n      h2 {\n        font-size: 34px;\n      }\n    }\n  }\n  .sidebar {\n    .widget {\n      .widget-title {\n        font-size: 20px;\n      }\n    }\n  }\n  .countdown1 {\n    #timer {\n      div {\n        font-size: 50px;\n      }\n    }\n  }\n\n  .elkevent-nav {\n    nav {\n      .others-option {\n        .btn {\n          font-size: 14px;\n          padding: 14px 20px;\n        }\n      }\n    }\n  }\n\n  .tabs {\n    li {\n      a {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .home-slides {\n    .main-banner-content {\n      text-align: center;\n    }\n  }\n  .page-title-area {\n    padding-top: 200px;\n    padding-bottom: 130px;\n  }\n\n  .slideshow-banner {\n    .main-banner-content {\n      text-align: center;\n    }\n    .event-countdown {\n      text-align: center;\n      bottom: 5px;\n\n      #timer {\n        span {\n          font-size: 10px;\n          right: -35px;\n        }\n\n        div {\n          font-size: 45px;\n        }\n      }\n\n      #timer div#hours span {\n        right: -41px;\n      }\n      #timer div#minutes span {\n        right: -48px;\n      }\n      #timer div#seconds span {\n        right: -50px;\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 1650px) {\n  .main-banner {\n    height: 100vh;\n  }\n\n  .event-countdown {\n    right: 20%;\n  }\n\n  .about-image {\n    .about-img1 {\n      right: -200px;\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .elkevent-nav {\n    nav {\n      .navbar-toggler {\n        outline: 0;\n        color: #ffffff;\n        border-color: #ffffff;\n      }\n      .navbar-toggler-icon {\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n      }\n      .collapse {\n        background-color: #000000;\n        padding: 15px 12px;\n        margin-top: 5px;\n        overflow-y: auto;\n        max-height: 60vh;\n\n        &::-webkit-scrollbar {\n          width: 10px;\n        }\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n        }\n        &::-webkit-scrollbar-thumb {\n          background: #888;\n        }\n        &::-webkit-scrollbar-thumb:hover {\n          background: #555;\n        }\n      }\n      .navbar-nav {\n        .nav-item {\n          padding: 8px 0;\n          a {\n            font-size: 15px;\n            margin: 0;\n          }\n          .dropdown-menu {\n            padding-top: 12px;\n            padding-bottom: 12px;\n            position: relative;\n            opacity: 1;\n            visibility: visible;\n            top: 0 !important;\n            width: 100%;\n            margin-top: 10px;\n            li {\n              a {\n                font-size: 14px;\n              }\n              .dropdown-menu {\n                padding-top: 12px;\n                padding-bottom: 12px;\n                position: relative;\n                opacity: 1 !important;\n                visibility: visible !important;\n                top: 0 !important;\n                width: 90%;\n                right: 0;\n                margin-top: 0;\n                margin-bottom: 10px;\n                background: #30334c;\n              }\n            }\n          }\n        }\n      }\n      .others-option {\n        margin-left: 0;\n        margin-top: 10px;\n      }\n    }\n  }\n}\n","@media (max-width: 767px) {\n  .elkevent-nav {\n    padding-top: 5px;\n  }\n  .elkevent-nav .navbar-brand img {\n    max-width: 100px;\n  }\n  .ptb-120 {\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n  .section-title span {\n    font-size: 13px;\n  }\n  .section-title h2 {\n    font-size: 25px;\n  }\n  .section-title .btn {\n    display: none;\n  }\n  .section-title .bg-title {\n    font-size: 30px !important;\n    line-height: 150% !important;\n    /* left: auto;\n    right: 0;\n    transform: unset !important; */\n  }\n  p {\n    font-size: 14px;\n  }\n  .btn {\n    font-size: 14px;\n    padding: 13px 24px;\n  }\n  .preloader .loader {\n    margin: -80px 0 0 -55px;\n  }\n  .main-banner {\n    height: 100%;\n    padding-top: 150px;\n    padding-bottom: 100px;\n  }\n  .main-banner-content {\n    text-align: center;\n  }\n  .main-banner-content::before {\n    display: none;\n  }\n  .main-banner-content h1 {\n    font-size: 28px;\n    line-height: 1.5;\n    font-weight: 800;\n  }\n  .main-banner-content h1 br {\n    display: none;\n  }\n  .main-banner-content p {\n    font-size: 15px;\n  }\n  .main-banner-content ul {\n    margin: 20px 0 30px;\n  }\n  .main-banner-content ul li {\n    font-size: 15px;\n    margin-top: 4px;\n    margin-bottom: 4px;\n  }\n  .main-banner-content .button-box .video-btn {\n    margin-left: 15px;\n    margin-top: 25px;\n  }\n  .main-banner-content.banner-content-center {\n    margin: 0 auto 0;\n    text-align: center;\n    width: 90% !important;\n  }\n  .event-countdown {\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    margin: 50px auto 0;\n    text-align: center;\n    position: inherit;\n  }\n  .event-countdown #timer div {\n    font-size: 30px;\n    margin: 0 20px 0 0;\n    position: relative;\n  }\n  .event-countdown #timer div:last-child {\n    margin-right: 0;\n  }\n  .event-countdown #timer div:first-child {\n    margin-left: 0;\n  }\n  .event-countdown #timer div span {\n    margin-top: 0;\n    font-size: 12px;\n    position: relative;\n    right: 0;\n    top: 0;\n    transform: unset;\n    margin-top: -5px;\n    letter-spacing: 1px;\n  }\n  .event-countdown #timer div#hours span {\n    right: 0;\n    margin-top: -5px;\n  }\n  .event-countdown #timer div#minutes span {\n    right: 0;\n    margin-top: -5px;\n  }\n  .event-countdown #timer div#seconds span {\n    right: 0;\n    margin-top: -5px;\n  }\n  .shape1,\n  .shape2,\n  .shape3,\n  .shape4 {\n    display: none;\n  }\n  .slideshow-banner .event-countdown {\n    text-align: center;\n    margin-left: 0;\n    margin-top: 0;\n    margin-bottom: 25px;\n  }\n  .slideshow-banner .event-countdown #timer div {\n    font-size: 30px;\n    margin: 0 22px 0 0;\n  }\n  .slideshow-banner .event-countdown #timer div:last-child {\n    margin-right: 0;\n  }\n  .home-slides .swiper-button-next,\n  .home-slides .swiper-button-prev {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    top: auto;\n    bottom: 10px;\n  }\n  .home-slides .swiper-button-next::after,\n  .home-slides .swiper-button-prev::after {\n    font-size: 20px;\n  }\n  .about-content span {\n    font-size: 16px;\n  }\n  .about-content h2 {\n    font-size: 25px;\n    margin-bottom: 15px;\n  }\n  .about-content h6 {\n    font-size: 15px;\n  }\n  .about-image {\n    margin-top: 40px;\n  }\n  .about-image .about-img1 {\n    right: 0;\n    top: 0;\n    width: 100%;\n  }\n  .about-image .about-img2 {\n    position: relative;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    margin-top: 20px;\n  }\n  .about-image .shape-img {\n    top: 27%;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n  }\n  .about-image .btn {\n    bottom: 0;\n    right: 15px;\n    transform: unset !important;\n  }\n  .about-area-two .about-content .signature {\n    margin-bottom: 0;\n  }\n  .about-area-three .about-content .signature {\n    margin-bottom: 0;\n  }\n  .about-area-three .about-image {\n    margin-top: 0;\n    margin-bottom: 30px;\n  }\n  .about-area-three .about-image .about-img1 {\n    margin-top: 0;\n  }\n  .about-area-three .about-image .btn {\n    left: auto;\n    bottom: 30px;\n    right: 15px;\n  }\n  .countdown-area .event-countdown {\n    margin: 0;\n  }\n  .countdown-area .event-countdown #timer {\n    overflow: hidden;\n    margin: 0 -10px;\n    text-align: center;\n  }\n  .countdown-area .event-countdown #timer div {\n    margin: 0;\n    text-align: center;\n    padding: 0 10px;\n  }\n  .why-choose-us {\n    padding-top: 60px;\n    padding-bottom: 35px;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .why-choose-us::before {\n    opacity: 0.8;\n  }\n  .single-box {\n    height: 100%;\n    margin-bottom: 30px;\n    padding-left: 15px;\n    padding-right: 15px;\n    border: none !important;\n  }\n  .single-box .d-table {\n    height: auto;\n    display: block;\n  }\n  .single-box .d-table-cell {\n    display: block;\n  }\n  .single-box .content {\n    position: relative;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .single-box .content .btn {\n    opacity: 1;\n    visibility: visible;\n    margin-top: 20px;\n  }\n  .single-box .content .icon {\n    font-size: 35px;\n  }\n  .single-box .content h3 {\n    font-size: 20px;\n  }\n  .single-box:hover .content,\n  .single-box:focus .content {\n    bottom: 0;\n  }\n  .single-box:hover .content p,\n  .single-box:focus .content p {\n    margin-bottom: 0;\n  }\n  .single-box::before {\n    display: none;\n  }\n  .why-choose-content {\n    padding: 35px 25px;\n  }\n  .why-choose-content h3 {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n  .why-choose-content span {\n    margin: 0 auto 0;\n    font-size: 60px;\n  }\n  .single-speakers .speakers-content {\n    bottom: 20px;\n    left: 20px;\n    text-align: center;\n    width: 100%;\n  }\n  .single-speakers .speakers-content h3 {\n    font-size: 18px;\n    margin-bottom: 0;\n  }\n  .single-speakers .speakers-content span {\n    font-size: 14px;\n  }\n  .single-speakers:hover .speakers-content,\n  .single-speakers:focus .speakers-content {\n    bottom: 20px;\n  }\n  .single-speakers ul {\n    padding: 10px;\n  }\n  .single-speakers ul li a {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    font-size: 14px;\n  }\n  .elkevent-single-speakers .speakers-content h3 {\n    font-size: 18px;\n  }\n  .elkevent-single-speakers .speakers-content span {\n    font-size: 14px;\n  }\n  .speakers-area-two {\n    padding-bottom: 30px;\n  }\n  .single-speakers-box .speakers-content h3 {\n    font-size: 20px;\n  }\n  .single-speakers-box .speakers-content span {\n    font-size: 13px;\n  }\n  .event-tabs .react-tabs__tab-list {\n    display: block;\n    margin-bottom: 0;\n  }\n  .event-tabs .react-tabs__tab-list li {\n    display: block;\n    font-size: 20px;\n    padding: 20px 10px;\n  }\n  .event-tabs .react-tabs__tab-list li::before {\n    display: none;\n  }\n  .event-tabs .react-tabs__tab-list li span {\n    font-size: 16px;\n  }\n  .event-tabs .react-tabs__tab-panel {\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-bottom: 10px;\n    padding-top: 10px;\n  }\n  .event-tabs .react-tabs__tab-panel .accordion .accordion__item {\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-bottom: 20px;\n    padding-top: 20px;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__item\n    .accordion__button {\n    display: block;\n    padding-left: 0;\n    padding-right: 0;\n    padding-bottom: 25px;\n    padding-top: 0;\n    text-align: center;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .author {\n    margin-right: auto;\n    margin-bottom: 15px;\n    margin-left: auto;\n    position: relative;\n    top: 0;\n    transform: unset;\n    right: 0;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .schedule-info\n    h3 {\n    margin-bottom: 10px;\n    line-height: 28px;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .schedule-info\n    ul\n    li {\n    margin-right: 0;\n    margin-bottom: 10px;\n    display: block;\n    font-size: 14px;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .schedule-info\n    ul\n    li:last-child {\n    margin-bottom: 0;\n  }\n  .event-tabs .react-tabs__tab-panel .accordion .accordion__panel {\n    padding: 0;\n  }\n  .event-tabs .react-tabs__tab-panel .accordion .accordion__panel p {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__panel\n    .row\n    .text-right {\n    text-align: left !important;\n    margin-top: 15px;\n  }\n  .schedule-slides-item .single-schedule {\n    padding: 0 0 0 0;\n  }\n  .schedule-slides-item .single-schedule .schedule-date {\n    font-size: 20px;\n    padding: 25px;\n    position: relative;\n    width: auto;\n  }\n  .schedule-slides-item .single-schedule .schedule-date span {\n    font-size: 14px;\n  }\n  .schedule-slides-item .single-schedule .schedule-content {\n    display: block;\n    text-align: center;\n  }\n  .schedule-slides-item .single-schedule .schedule-content .author {\n    margin-right: auto;\n    margin-bottom: 15px;\n    margin-left: auto;\n  }\n  .schedule-slides-item .single-schedule .schedule-content .schedule-info h3 {\n    margin-bottom: 12px;\n    line-height: 28px;\n  }\n  .schedule-slides-item\n    .single-schedule\n    .schedule-content\n    .schedule-info\n    ul\n    li {\n    margin-right: 0;\n    margin-bottom: 10px;\n    display: block;\n    font-size: 14px;\n  }\n  .schedule-slides-item\n    .single-schedule\n    .schedule-content\n    .schedule-info\n    ul\n    li:last-child {\n    margin-bottom: 0;\n  }\n  .schedule-style-three {\n    padding-bottom: 30px;\n  }\n  .single-schedule-item .schedule-date {\n    font-size: 20px;\n    padding: 25px;\n    position: relative;\n    width: auto;\n  }\n  .single-schedule-item .schedule-date span {\n    font-size: 14px;\n  }\n  .single-schedule-item .schedule-item-wrapper .schedule-content {\n    display: block;\n    text-align: center;\n  }\n  .single-schedule-item .schedule-item-wrapper .schedule-content .author {\n    margin-right: auto;\n    margin-bottom: 15px;\n    margin-left: auto;\n  }\n  .single-schedule-item\n    .schedule-item-wrapper\n    .schedule-content\n    .schedule-info\n    h3 {\n    margin-bottom: 12px;\n    line-height: 28px;\n  }\n  .single-schedule-item\n    .schedule-item-wrapper\n    .schedule-content\n    .schedule-info\n    ul\n    li {\n    margin-right: 0;\n    margin-bottom: 10px;\n    display: block;\n    font-size: 14px;\n  }\n  .single-schedule-item\n    .schedule-item-wrapper\n    .schedule-content\n    .schedule-info\n    ul\n    li:last-child {\n    margin-bottom: 0;\n  }\n  .btn-box {\n    margin-top: 20px;\n  }\n  .btn-box .btn {\n    margin: 20px 10px 0;\n  }\n  .schedule-slides.owl-theme .owl-nav {\n    margin-top: 30px;\n  }\n  .schedule-slides.owl-theme .owl-nav [class*=\"owl-\"] {\n    font-size: 25px;\n    position: relative;\n    left: 0;\n    top: 0;\n    right: 0 !important;\n  }\n  .schedule-style-four .col-lg-8 {\n    order: 2;\n  }\n  .schedule-style-four .col-lg-4 {\n    order: 1;\n  }\n  .funfacts-area {\n    padding-bottom: 30px;\n  }\n  .single-funfact {\n    margin-bottom: 30px;\n  }\n  .single-funfact .icon {\n    font-size: 30px;\n  }\n  .single-funfact h3 {\n    font-size: 35px;\n    margin-top: 8px;\n  }\n  .single-funfact p {\n    font-size: 13px;\n  }\n  .funFact {\n    text-align: center;\n    margin-bottom: 35px;\n    padding-left: 0;\n  }\n  .funFact .icon {\n    font-size: 30px;\n    position: relative;\n  }\n  .funFact h3 {\n    font-size: 35px;\n    margin-top: 8px;\n  }\n  .funFact p {\n    font-size: 14px;\n  }\n  .cta-area {\n    text-align: center;\n  }\n  .cta-area span {\n    font-size: 15px;\n  }\n  .cta-area h3 {\n    font-size: 24px;\n  }\n  .cta-area .text-right {\n    text-align: center !important;\n    margin-top: 25px;\n  }\n  .pricing-area {\n    padding-bottom: 30px;\n  }\n  .pricing-table-box {\n    margin-bottom: 30px;\n  }\n  .pricing-table-box .title {\n    font-size: 17px;\n  }\n  .pricing-table-box .price-value {\n    font-size: 35px;\n  }\n  .pricing-table-box .price-value sup {\n    font-size: 20px;\n    top: -18px;\n  }\n  .pricing-table-box .pricing-content li {\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    font-size: 14px;\n  }\n  .pricing-table-box .pricing-content li:last-child {\n    margin-bottom: 0;\n  }\n  .pricing-plan {\n    margin-bottom: 30px;\n  }\n  .pricing-plan h3 {\n    font-size: 20px;\n  }\n  .pricing-plan h3 span {\n    height: 130px;\n    width: 130px;\n    line-height: 135px;\n    font-size: 25px;\n  }\n  .pricing-plan .pricing-content li {\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    font-size: 14px;\n  }\n  .pricing-plan .pricing-content li:last-child {\n    margin-bottom: 0;\n  }\n  .partner-area .section-title {\n    text-align: center;\n  }\n  .partner-area .section-title .bar {\n    display: none;\n  }\n  .partner-area .partner-title {\n    margin-bottom: 40px;\n    transform: unset !important;\n  }\n  .partner-area .partner-title h3 {\n    font-size: 18px;\n    font-weight: 600;\n  }\n  .single-blog-post .blog-post-content {\n    padding: 20px;\n  }\n  .single-blog-post .blog-post-content .date {\n    font-size: 13px;\n  }\n  .single-blog-post .blog-post-content h3 {\n    line-height: 28px;\n    font-size: 18px;\n  }\n  .blog-section {\n    padding-bottom: 30px;\n  }\n  .single-blog-card .post-tag {\n    top: 15px;\n  }\n  .single-blog-card .blog-post-content {\n    padding: 0 20px 20px;\n  }\n  .single-blog-card .blog-post-content p,\n  .single-blog-card .blog-post-content .read-more-btn {\n    display: none;\n  }\n  .single-blog-card .blog-post-content h3 {\n    font-size: 18px;\n    margin-bottom: 0;\n  }\n  .single-blog-card:hover .post-tag,\n  .single-blog-card:focus .post-tag {\n    top: 15px;\n  }\n  .buy-tickets-area.ptb-120 {\n    padding-bottom: 140px;\n  }\n  .subscribe-area::before {\n    height: 74%;\n  }\n  .subscribe-area .subscribe-inner {\n    padding: 20px;\n  }\n  .subscribe-area .subscribe-inner p {\n    font-size: 13px;\n  }\n  .subscribe-area .subscribe-inner h2 a {\n    font-size: 18px;\n    line-height: 36px;\n  }\n  .subscribe-area .subscribe-inner .newsletter-form .form-control {\n    height: 50px;\n  }\n  .subscribe-area .subscribe-inner .newsletter-form .btn {\n    position: relative;\n    height: 54px;\n    display: block;\n    width: 100%;\n    margin-top: 10px;\n  }\n  .page-title-area {\n    padding-top: 160px;\n    padding-bottom: 100px;\n  }\n  .page-title-area h1 {\n    font-size: 28px;\n  }\n  .page-title-area span {\n    margin-top: 10px;\n    font-size: 15px;\n  }\n  .page-title-area ul li {\n    font-size: 15px;\n  }\n  .login-area {\n    height: 100%;\n    padding: 120px 15px 120px;\n  }\n  .login-area .login-form p {\n    text-align: center;\n  }\n  .login-area .login-form p a.pull-right {\n    float: unset;\n    margin-top: 5px;\n  }\n  .login-area .login-form p a.pull-left {\n    float: unset;\n  }\n  .signup-area {\n    height: 100%;\n    padding: 120px 15px 120px;\n  }\n  .signup-area .signup-form h3 {\n    font-size: 20px;\n  }\n  .coming-soon {\n    height: 100%;\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n  .coming-soon .coming-soon-content h1 {\n    font-size: 30px;\n    line-height: 45px;\n  }\n  .coming-soon .coming-soon-content #timer div {\n    font-size: 40px;\n    width: 120px;\n    height: 120px;\n    padding-top: 27px;\n    line-height: 39px;\n    margin: 0 5px 15px;\n  }\n  .coming-soon .coming-soon-content form button {\n    position: relative;\n    right: 0;\n    top: 0;\n    width: 100%;\n    border-radius: 30px;\n    margin-top: 10px;\n    padding: 13px 0;\n  }\n  .error-area h1 {\n    font-size: 110px;\n    line-height: 85px;\n  }\n  .error-area h3 {\n    margin: 30px 0 15px;\n    font-size: 20px;\n  }\n  .faq-accordion {\n    box-shadow: unset;\n    padding: 0;\n  }\n  .faq-accordion .accordion .accordion-title {\n    padding: 10px 10px 10px 50px;\n    font-size: 14px;\n  }\n  .faq-contact {\n    box-shadow: unset;\n    padding: 0;\n  }\n  .faq-contact h3 {\n    font-size: 20px;\n    margin-bottom: 25px;\n  }\n  .sidebar {\n    margin-top: 50px;\n  }\n  .sidebar .widget .widget-title {\n    font-size: 18px;\n  }\n  .sidebar .widget.widget_recent_entries ul li h5 {\n    font-size: 14px;\n  }\n  .blog-details h3 {\n    font-size: 20px;\n    line-height: 30px;\n  }\n  .blog-details blockquote,\n  .blog-details .blockquote {\n    padding: 88px 20px 20px 20px;\n    border-width: 3px;\n  }\n  .blog-details blockquote::before,\n  .blog-details .blockquote::before {\n    left: 20px;\n    top: 20%;\n  }\n  .blog-details blockquote p,\n  .blog-details .blockquote p {\n    font-size: 15px;\n  }\n  .post-tag-media {\n    text-align: center;\n  }\n  .post-tag-media ul.social-share {\n    text-align: center;\n    margin-top: 15px;\n  }\n  .comments-area .comments-title,\n  .comments-area .comment-reply-title {\n    font-size: 20px;\n  }\n  .comments-area ol li .comment-body,\n  .comments-area ul li .comment-body {\n    padding: 20px 15px;\n  }\n  .comments-area ol li .comment-body .comment-meta .comment-author .fn,\n  .comments-area ul li .comment-body .comment-meta .comment-author .fn {\n    font-size: 16px;\n  }\n  .comments-area ol li .comment-body .reply,\n  .comments-area ul li .comment-body .reply {\n    position: relative;\n    right: 0;\n    top: 0;\n    margin-top: 20px;\n  }\n  .contact-box {\n    margin-bottom: 30px;\n  }\n  .contact-box h4 {\n    font-size: 18px;\n  }\n  .contact-form {\n    margin-top: 0;\n  }\n  .leave-your-message h3 {\n    font-size: 18px;\n  }\n  #contactForm {\n    margin-top: 30px;\n    padding: 20px 15px;\n  }\n  .footer-area {\n    padding-top: 60px;\n  }\n  .single-footer-widget {\n    margin-bottom: 30px;\n  }\n  .single-footer-widget h3 {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n  .single-footer-widget span {\n    font-size: 14px;\n  }\n  .single-footer-widget a {\n    font-size: 14px;\n  }\n  .copyright-area {\n    margin-top: 20px;\n  }\n  .copyright-area ul {\n    margin: 25px 0 18px;\n  }\n  .countdown1 {\n    /* position: initial; */\n    text-align: center !important;\n  }\n  .countdown1 #timer div {\n    font-size: 30px;\n    margin: 0 20px 0 0;\n  }\n  .blog-slides.owl-theme .owl-nav.disabled + .owl-dots {\n    margin-top: 0;\n  }\n  .buy-tickets {\n    text-align: center;\n  }\n  .buy-tickets .buy-ticket-btn {\n    text-align: center;\n    margin-top: 30px;\n  }\n  .copyright-area .logo img {\n    max-width: 100px;\n  }\n  .speakers-area .p-0 {\n    padding: 12px !important;\n  }\n  .speakers-area .single-speakers,\n  /* .speakers-area .elkevent-single-speakers {\n    margin-bottom: 30px;\n  } */\n  section.speakers-area.ptb-120.pb-0 {\n    padding-bottom: 30px !important;\n  }\n  .slideshow-banner .main-banner-content {\n    margin-top: 0;\n  }\n  .modal-video-body {\n    padding: 0 20px;\n  }\n  .modal-video-body .modal-video-close-btn {\n    right: 0;\n  }\n}\n@media only screen and (min-width: 423px) and (max-width: 767px) {\n  .main-banner-content .button-box .video-btn {\n    margin-top: 0;\n  }\n}\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .schedule-area .tabs li {\n    width: 50%;\n    display: inline-block;\n  }\n  .why-choose-us-two {\n    max-width: 540px;\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 992px) {\n  .speakers-area .p-0 {\n    padding: 12px !important;\n  }\n  .elkevent-nav {\n    padding-top: 10px;\n  }\n  .elkevent-nav .navbar-brand {\n    padding-top: 0;\n  }\n  .elkevent-nav .navbar-brand img {\n    max-width: 90px;\n  }\n  .countdown1 {\n    bottom: 25px !important;\n  }\n  .copyright-area .logo img {\n    max-width: 100px;\n  }\n  .ptb-120 {\n    padding-top: 80px;\n    padding-bottom: 80px;\n  }\n  .event-countdown {\n    bottom: 15px;\n  }\n  .event-countdown #timer span {\n    font-size: 12px;\n  }\n  .slideshow-banner .event-countdown {\n    text-align: center;\n  }\n  .buy-tickets {\n    text-align: center;\n  }\n  .buy-tickets .buy-ticket-btn {\n    text-align: center;\n    margin-top: 30px;\n  }\n  .section-title span {\n    font-size: 14px;\n  }\n  .section-title h2 {\n    font-size: 30px;\n  }\n  .section-title .bg-title {\n    font-size: 100px !important;\n    line-height: 150% !important;\n    right: 20%;\n    margin-top: -10px;\n    transform: unset !important;\n  }\n  .section-title .btn {\n    margin-top: -25px;\n  }\n  .elkevent-mobile-nav .logo {\n    left: 40px !important;\n  }\n  .elkevent-mobile-nav.mean-container a.meanmenu-reveal {\n    padding: 12px 40px 0 0;\n  }\n  .main-banner {\n    height: 100%;\n    padding-top: 200px;\n    padding-bottom: 200px;\n  }\n  .main-banner-content {\n    text-align: center;\n  }\n  .main-banner-content::before {\n    display: none;\n  }\n  .main-banner-content p {\n    font-size: 18px;\n  }\n  .main-banner-content h1 {\n    font-size: 40px;\n    line-height: 1.4;\n  }\n  .main-banner-content ul li {\n    font-size: 15px;\n  }\n  .main-banner-content.banner-content-center {\n    margin-top: 0;\n  }\n  .event-countdown #timer div {\n    margin: 0 25px;\n    font-size: 50px;\n  }\n  .event-countdown #timer div span {\n    font-size: 13px;\n    right: -30px;\n    margin-top: -11px;\n    letter-spacing: 0;\n  }\n  .event-countdown #timer div#hours span {\n    right: -36px;\n    margin-top: -10px;\n  }\n  .event-countdown #timer div#minutes span {\n    right: -42px;\n    margin-top: -10px;\n  }\n  .event-countdown #timer div#seconds span {\n    right: -44px;\n    margin-top: -10px;\n  }\n  .subscribe-area .subscribe-inner .newsletter-form .btn {\n    height: 50px;\n  }\n  .countdown-area .event-countdown #timer div {\n    margin: 0 30px;\n  }\n  .about-content span {\n    font-size: 16px;\n  }\n  .about-content h2 {\n    font-size: 30px;\n    margin-bottom: 20px;\n  }\n  .about-image {\n    margin-top: 50px;\n  }\n  .about-image .about-img1 {\n    position: relative;\n    right: 0;\n    top: 0;\n  }\n  .about-image .about-img2 {\n    display: none;\n  }\n  .about-image .btn {\n    bottom: 0;\n    right: 25px;\n    transform: unset !important;\n  }\n  .about-area-three .about-image {\n    margin-bottom: 30px;\n  }\n  .about-area-three .about-image .about-img1 {\n    width: 100%;\n  }\n  .about-area-three .about-image .btn {\n    bottom: 30px;\n  }\n  .why-choose-us {\n    padding-top: 80px;\n    padding-bottom: 50px;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .single-box {\n    height: 100%;\n    margin-bottom: 30px;\n    border: none !important;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .single-box .d-table {\n    height: auto;\n    display: block;\n  }\n  .single-box .d-table-cell {\n    display: block;\n  }\n  .single-box .content {\n    position: relative;\n    z-index: 2;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .single-box .content .btn {\n    opacity: 1;\n    visibility: visible;\n    margin-top: 20px;\n  }\n  .single-box .content .icon {\n    font-size: 35px;\n    line-height: 40px;\n  }\n  .single-box .content h3 {\n    font-size: 22px;\n  }\n  .single-box:hover .content,\n  .single-box:focus .content {\n    bottom: 0;\n  }\n  .single-box:hover .content p,\n  .single-box:focus .content p {\n    margin-bottom: 0;\n  }\n  .why-choose-content h3 {\n    font-size: 22px;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(1) {\n    order: 1;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(2) {\n    order: 2;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(3) {\n    order: 4;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(4) {\n    order: 3;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(5) {\n    order: 5;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(6) {\n    order: 6;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(7) {\n    order: 7;\n  }\n  .why-choose-us-two .col-lg-4:nth-child(8) {\n    order: 8;\n  }\n  .single-speakers .speakers-content h3 {\n    font-size: 22px;\n  }\n  .elkevent-single-speakers .speakers-content h3 {\n    font-size: 20px;\n  }\n  .speakers-area-two {\n    padding-bottom: 50px;\n  }\n  .single-speakers-box .speakers-content h3 {\n    font-size: 20px;\n  }\n  .shape1,\n  .shape2,\n  .shape3,\n  .shape4 {\n    display: none;\n  }\n  .event-tabs .react-tabs__tab-list li {\n    font-size: 18px;\n  }\n  .event-tabs .react-tabs__tab-list li span {\n    font-size: 16px;\n  }\n  .event-tabs\n    .accordion__panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .schedule-info\n    h3 {\n    padding-right: 115px;\n    line-height: 1.4;\n  }\n  .event-tabs\n    .accordion__panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .schedule-info\n    ul\n    li {\n    font-size: 13px;\n  }\n  .schedule-slides-item .single-schedule {\n    padding: 0 0 0 175px;\n  }\n  .schedule-slides-item .single-schedule .schedule-date {\n    font-size: 22px;\n    padding: 20px 20px;\n    width: 175px;\n  }\n  .schedule-slides-item .single-schedule .schedule-date span {\n    font-size: 14px;\n  }\n  .schedule-slides-item .single-schedule .schedule-content .schedule-info h3 {\n    margin-bottom: 10px;\n  }\n  .schedule-slides-item\n    .single-schedule\n    .schedule-content\n    .schedule-info\n    ul\n    li {\n    margin-right: 10px;\n    font-size: 13px;\n  }\n  .schedule-slides.owl-theme .owl-nav [class*=\"owl-\"] {\n    left: -15px;\n  }\n  .schedule-slides.owl-theme .owl-nav [class*=\"owl-\"].owl-next {\n    right: -15px;\n    left: auto;\n  }\n  .schedule-style-three {\n    padding-bottom: 50px;\n  }\n  .single-schedule-item\n    .schedule-item-wrapper\n    .schedule-content\n    .schedule-info\n    ul\n    li {\n    font-size: 14px;\n  }\n  .schedule-style-four\n    .tab_content\n    .tabs_item\n    .accordion\n    .accordion-item\n    .accordion-title\n    .schedule-info\n    ul\n    li {\n    font-size: 14px;\n    display: block;\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n  .schedule-style-four\n    .tab_content\n    .tabs_item\n    .accordion\n    .accordion-item\n    .accordion-title\n    .schedule-info\n    ul\n    li:last-child {\n    margin-bottom: 0;\n  }\n  .single-funfact .icon {\n    font-size: 35px;\n  }\n  .single-funfact h3 {\n    font-size: 40px;\n  }\n  .funFact {\n    padding-left: 0;\n    text-align: center;\n  }\n  .funFact .icon {\n    font-size: 35px;\n    position: relative;\n  }\n  .funFact h3 {\n    margin-top: 10px;\n    font-size: 40px;\n  }\n  /* .event-countdown {\n    right: 0;\n    text-align: center;\n    left: 0;\n  } */\n  .pricing-area {\n    padding-bottom: 50px;\n  }\n  .pricing-table-box {\n    margin-bottom: 30px;\n  }\n  .pricing-table-box .title {\n    font-size: 22px;\n  }\n  .pricing-table-box .price-value {\n    font-size: 40px;\n  }\n  .pricing-table-box .price-value sup {\n    font-size: 20px;\n    top: -20px;\n  }\n  .pricing-plan {\n    margin-bottom: 30px;\n  }\n  .pricing-plan h3 {\n    font-size: 22px;\n  }\n  .pricing-plan h3 span {\n    height: 140px;\n    width: 140px;\n    line-height: 145px;\n    font-size: 30px;\n  }\n  .partner-area .partner-title {\n    margin-bottom: 40px;\n    transform: unset !important;\n  }\n  .partner-area .partner-title h3 {\n    font-size: 20px;\n  }\n  .cta-area span {\n    font-size: 16px;\n  }\n  .cta-area h3 {\n    font-size: 30px;\n  }\n  .cta-area .text-right {\n    text-align: left !important;\n    margin-top: 25px;\n  }\n  .single-blog-post .blog-post-content h3 {\n    font-size: 20px;\n  }\n  .single-blog-card .blog-post-content {\n    padding: 0 20px 20px;\n  }\n  .single-blog-card .blog-post-content h3 {\n    margin-bottom: 0;\n    font-size: 20px;\n  }\n  .single-blog-card .blog-post-content p,\n  .single-blog-card .blog-post-content .read-more-btn {\n    display: none;\n  }\n  .buy-tickets-area.ptb-120 {\n    padding-bottom: 175px;\n  }\n  .subscribe-area .subscribe-inner p {\n    font-size: 15px;\n  }\n  .subscribe-area .subscribe-inner h2 a {\n    font-size: 30px;\n  }\n  .page-title-area {\n    padding-top: 160px;\n    padding-bottom: 120px;\n  }\n  .page-title-area h1 {\n    font-size: 30px;\n  }\n  .page-title-area span {\n    margin-top: 8px;\n    font-size: 16px;\n  }\n  .login-area {\n    height: 100%;\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n  .signup-area {\n    height: 100%;\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n  .coming-soon {\n    height: 100%;\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n  .faq-accordion {\n    padding: 30px;\n  }\n  .faq-contact {\n    padding: 30px;\n  }\n  .faq-contact h3 {\n    font-size: 22px;\n  }\n  .sidebar {\n    margin-top: 50px;\n  }\n  .sidebar .widget .widget-title {\n    font-size: 20px;\n  }\n  .comments-area .comments-title,\n  .comments-area .comment-reply-title {\n    font-size: 20px;\n    margin-bottom: 25px;\n  }\n  .contact-box {\n    margin-bottom: 30px;\n    padding: 30px 20px 30px 75px;\n  }\n  .contact-box .icon {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 16px;\n  }\n  .contact-box h4 {\n    font-size: 18px;\n    margin-bottom: 13px;\n  }\n  .contact-box p {\n    margin-bottom: 3px;\n    font-size: 14px;\n  }\n  .contact-box p:last-child {\n    margin-bottom: 0;\n  }\n  .contact-form {\n    margin-top: 20px;\n  }\n  .leave-your-message h3 {\n    margin-bottom: 12px;\n    font-size: 20px;\n  }\n  #contactForm {\n    margin-top: 30px;\n  }\n  .footer-area {\n    padding-top: 80px;\n  }\n  .single-footer-widget h3 {\n    font-size: 22px;\n  }\n  .copyright-area {\n    margin-top: 60px;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item a {\n    font-size: 15px;\n    /* margin-left: 11px;\n    margin-right: 11px; */\n  }\n  .elkevent-nav nav .navbar-nav .nav-item:nth-last-child(1) .dropdown-menu,\n  .elkevent-nav nav .navbar-nav .nav-item:nth-last-child(2) .dropdown-menu,\n  .elkevent-nav nav .navbar-nav .nav-item:nth-last-child(3) .dropdown-menu {\n    left: auto;\n    right: 0;\n  }\n  .countdown1 #timer div {\n    margin: 0 20px;\n    font-size: 40px;\n  }\n  .single-funfact {\n    margin-bottom: 30px;\n  }\n  .funfacts-area.ptb-120 {\n    padding-bottom: 50px;\n  }\n  .modal-video-body {\n    padding: 0 30px;\n  }\n  .modal-video-body .modal-video-close-btn {\n    right: 0;\n  }\n}\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .elkevent-nav .navbar-brand {\n    padding-top: 0;\n  }\n  .elkevent-nav .navbar-brand img {\n    max-width: 100px;\n  }\n  .copyright-area .logo img {\n    max-width: 100px;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item a {\n    font-size: 15px;\n  }\n  .main-banner-content p {\n    font-size: 20px;\n  }\n  .main-banner-content h1 {\n    font-size: 45px;\n    font-weight: 800;\n    line-height: 1.3;\n  }\n  .event-countdown #timer div {\n    font-size: 50px;\n  }\n  .about-content span {\n    font-size: 16px;\n  }\n  .about-content h2 {\n    font-size: 27px;\n    margin-bottom: 20px;\n  }\n  .about-content h6 {\n    margin-bottom: 15px;\n  }\n  .about-content .signature {\n    margin-top: 25px;\n  }\n  .about-image .about-img1 {\n    width: 85%;\n    top: -145px;\n    right: -40px;\n  }\n  .about-image .about-img2 {\n    left: 0;\n    bottom: -142px;\n  }\n  .about-image .btn {\n    bottom: 0;\n    transform: unset !important;\n  }\n  .about-area-three .about-image img {\n    width: 100%;\n  }\n  .why-choose-content {\n    padding: 10px;\n  }\n  .why-choose-content h3 {\n    font-size: 22px;\n    margin-bottom: 10px;\n  }\n  .single-box .content {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .single-box .content h3 {\n    font-size: 22px;\n  }\n  .single-box .content::before {\n    display: none;\n  }\n  .cta-area h3 {\n    font-size: 30px;\n  }\n  .cta-area span {\n    font-size: 15px;\n  }\n  .single-speakers .speakers-content {\n    bottom: 15px;\n    left: 15px;\n  }\n  .single-speakers .speakers-content h3 {\n    font-size: 18px;\n  }\n  .single-speakers ul li a {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    font-size: 14px;\n  }\n  .single-speakers:hover .speakers-content,\n  .single-speakers:focus .speakers-content {\n    bottom: 12px;\n  }\n  .elkevent-single-speakers .speakers-content {\n    padding: 15px;\n  }\n  .elkevent-single-speakers .speakers-content h3 {\n    font-size: 18px;\n  }\n  .elkevent-single-speakers .speakers-content span {\n    font-size: 13px;\n    margin-top: 5px;\n  }\n  .elkevent-single-speakers ul li a {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    font-size: 14px;\n  }\n  .single-speakers-box .speakers-content h3 {\n    font-size: 20px;\n  }\n  .section-title span {\n    font-size: 15px;\n  }\n  .section-title h2 {\n    font-size: 34px;\n  }\n  .section-title .bg-title {\n    transform: unset !important;\n    font-size: 80px !important;\n  }\n  .event-tabs\n    .react-tabs__tab-panel\n    .accordion\n    .accordion__item\n    .accordion__button\n    .schedule-info\n    h3 {\n    font-size: 20px;\n  }\n  .single-schedule-item\n    .schedule-item-wrapper\n    .schedule-content\n    .schedule-info\n    ul\n    li {\n    font-size: 14px;\n    display: block;\n    margin-right: 0;\n    margin-bottom: 5px;\n  }\n  .single-schedule-item\n    .schedule-item-wrapper\n    .schedule-content\n    .schedule-info\n    ul\n    li:last-child {\n    margin-bottom: 0;\n  }\n  .pricing-table-box .title {\n    font-size: 18px;\n  }\n  .pricing-table-box .price-value {\n    font-size: 40px;\n  }\n  .partner-area .partner-title {\n    transform: unset !important;\n  }\n  .partner-area .partner-title h3 {\n    font-size: 20px;\n  }\n  .subscribe-area .subscribe-inner p {\n    font-size: 15px;\n  }\n  .subscribe-area .subscribe-inner h2 a {\n    font-size: 34px;\n  }\n  .sidebar .widget .widget-title {\n    font-size: 20px;\n  }\n  .countdown1 #timer div {\n    font-size: 50px;\n  }\n  .elkevent-nav nav .others-option .btn {\n    font-size: 14px;\n    padding: 14px 20px;\n  }\n  .tabs li a {\n    font-size: 20px;\n  }\n  .home-slides .main-banner-content {\n    text-align: center;\n  }\n  .page-title-area {\n    padding-top: 200px;\n    padding-bottom: 130px;\n  }\n  .slideshow-banner .main-banner-content {\n    text-align: center;\n  }\n  .slideshow-banner .event-countdown {\n    text-align: center;\n    bottom: 5px;\n  }\n  .slideshow-banner .event-countdown #timer span {\n    font-size: 10px;\n    right: -35px;\n  }\n  .slideshow-banner .event-countdown #timer div {\n    font-size: 45px;\n  }\n  .slideshow-banner .event-countdown #timer div#hours span {\n    right: -41px;\n  }\n  .slideshow-banner .event-countdown #timer div#minutes span {\n    right: -48px;\n  }\n  .slideshow-banner .event-countdown #timer div#seconds span {\n    right: -50px;\n  }\n}\n@media only screen and (min-width: 1600px) {\n  .main-banner {\n    height: 100vh;\n  }\n  .event-countdown {\n    right: 20%;\n  }\n  .about-image .about-img1 {\n    right: -200px;\n  }\n\n  .container {\n    max-width: 80% !important;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .elkevent-nav nav .navbar-toggler {\n    outline: 0;\n    color: #ffffff;\n    border-color: transparent !important;\n  }\n  .elkevent-nav nav .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n  }\n  .elkevent-nav nav .collapse {\n    background-color: #000000;\n    padding: 15px 12px;\n    margin-top: 5px;\n    overflow-y: auto;\n    max-height: 60vh;\n  }\n  .elkevent-nav nav .collapse::-webkit-scrollbar {\n    width: 10px;\n  }\n  .elkevent-nav nav .collapse::-webkit-scrollbar-track {\n    background: #f1f1f150;\n  }\n  .elkevent-nav nav .collapse::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 5px;\n  }\n  .elkevent-nav nav .collapse::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item {\n    padding: 8px 0;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item a {\n    font-size: 15px;\n    margin: 0;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item .dropdown-menu {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    position: relative;\n    opacity: 1;\n    visibility: visible;\n    top: 0 !important;\n    width: 100%;\n    margin-top: 10px;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a {\n    font-size: 14px;\n  }\n  .elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li .dropdown-menu {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    position: relative;\n    opacity: 1 !important;\n    visibility: visible !important;\n    top: 0 !important;\n    width: 90%;\n    /* left: 15px; */\n    margin-top: 0;\n    margin-bottom: 10px;\n    background: #30334c;\n  }\n  .elkevent-nav nav .others-option {\n    margin-left: 0;\n    margin-top: 10px;\n  }\n} /*# sourceMappingURL=responsive.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
